var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrmsLogin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-83",
    d: "M85,447.44C-6.08,394.84-6.08,309.55,85,257s238.83-52.6,329.94,0,91.11,137.89,0,190.49S176.14,500.05,85,447.44Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.11,30.05l8.22,4.74a10.13,10.13,0,0,1-.07-1.09V31.32c0-4.23,3-5.95,6.64-3.83a12.85,12.85,0,0,1,4,3.8c.6-5.32,4.78-7.3,9.85-4.37,5.49,3.16,9.94,10.87,9.94,17.2v3.56a9.34,9.34,0,0,1-.84,4.13l6.82,3.94a8.13,8.13,0,0,1,3.69,6.38c0,2.35-1.65,3.3-3.69,2.13L364.11,38.55a8.14,8.14,0,0,1-3.68-6.38C360.43,29.82,362.08,28.87,364.11,30.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.23,64.9l-4.43-3.4V51.75c0-7.72-6.16-16.69-12.85-20.55h0c-6.69-3.86-12.11-.73-12.11,7v1.42A17.36,17.36,0,0,0,441.22,34h0c-4.82-2.78-8.72-.52-8.72,5v.64l-6.17-3.56c-3.17-1.83-5.74-.35-5.74,3.31a12.68,12.68,0,0,0,5.74,9.94l49.9,28.81c3.17,1.83,5.74.35,5.74-3.31A12.7,12.7,0,0,0,476.23,64.9Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-83",
    d: "M245.83,350.88l-11.49-6.63a8.84,8.84,0,0,0-8.41.21l-59.3,38.24c-11.57-6.75-27.56-10.93-45.22-10.93-35.33,0-64,16.72-64,37.34s28.64,37.35,64,37.35,64-16.72,64-37.35c0-6.59-2.94-12.78-8.08-18.16l68.42-35.34C248.14,354.36,248.19,352.24,245.83,350.88Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-83",
    cx: 290.32,
    cy: 430.69,
    rx: 80.14,
    ry: 46.27,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.91,21.76c-3.52-2-8.35-1.69-13.69,1.4-10.74,6.2-19.44,21.28-19.44,33.68,0,6.19,2.17,10.54,5.68,12.57l6.65,3.83c3.51,2,8.37,1.73,13.73-1.37,10.74-6.2,19.45-21.28,19.45-33.68,0-6.18-2.17-10.53-5.67-12.56C224.15,24.77,220.39,22.61,218.91,21.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,73.51a14.49,14.49,0,0,1-4.87,4.81,13.35,13.35,0,0,1-7.29,1.84.71.71,0,0,1-.34-.08l-6.62-3.81a.67.67,0,0,1,0-1.15A11.75,11.75,0,0,0,188,66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88,79.7a.17.17,0,0,1-.18-.14.17.17,0,0,1,.09-.22,12.16,12.16,0,0,0,6.29-9.51l0-.16-.08-.14a16.94,16.94,0,0,1-2.15-8.88c0-12.24,8.61-27.16,19.21-33.28a17.09,17.09,0,0,1,8.45-2.59c6.34,0,10.29,5.14,10.29,13.41,0,12.23-8.62,27.16-19.21,33.27a17.09,17.09,0,0,1-8.44,2.59,10.53,10.53,0,0,1-2.48-.29l-.32-.08-.18.27a14.61,14.61,0,0,1-4.26,4A13.13,13.13,0,0,1,189,79.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.53,25.25c6.05,0,9.82,5,9.82,12.94,0,12.08-8.52,26.83-19,32.87a16.65,16.65,0,0,1-8.2,2.52,9.68,9.68,0,0,1-2.37-.28l-.63-.15-.37.54a14,14,0,0,1-4.12,3.84,12.05,12.05,0,0,1-5.8,1.68,12.49,12.49,0,0,0,5.67-9.34l0-.31-.16-.27a16.57,16.57,0,0,1-2.08-8.64c0-12.09,8.51-26.83,19-32.87a16.64,16.64,0,0,1,8.22-2.53m0-.94A17.64,17.64,0,0,0,211.84,27C201.1,33.17,192.4,48.24,192.4,60.65a17.26,17.26,0,0,0,2.22,9.13,11.72,11.72,0,0,1-6.07,9.15.67.67,0,0,0,.32,1.24H189a13.57,13.57,0,0,0,7.16-1.84,15,15,0,0,0,4.39-4.11,11,11,0,0,0,2.6.3,17.6,17.6,0,0,0,8.67-2.65c10.74-6.2,19.45-21.28,19.45-33.68,0-8.79-4.38-13.88-10.76-13.88Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.9,55.07a.58.58,0,0,1,.06-.26s1.56-3.24,2.42-5c.74-1.47,1.42-2.67,2.24-2.48.35.08.47.51.6,1a2.14,2.14,0,0,0,.76,1.37c.88.55,2.14-1,2.76-2.25s1.29-3.25.5-4a1.48,1.48,0,0,0-1.36-.24c-.4.06-.78.12-1-.22-.5-.82.11-2.07.89-3.51.91-1.67,2.64-4.73,2.66-4.76a.49.49,0,0,1,.21-.2.13.13,0,0,1,.18.07,25.8,25.8,0,0,0,1.74,2.66c1.51,2.09,2.28,1,2.84.25a2.74,2.74,0,0,0,.39-1.18,7.45,7.45,0,0,1,.71-2.24c.64-1.22,1.85-2.12,3-1.25a2.22,2.22,0,0,1,.85,1.73,4.22,4.22,0,0,1-.49,2.06,6.09,6.09,0,0,1-1.37,1.74,2.47,2.47,0,0,0-.72.93c-.34.95-.8,2.24,1.42,3a16.15,16.15,0,0,0,2.75.73c.07,0,.11.07.13.17a.59.59,0,0,1-.06.31s-1.56,3.24-2.42,4.95c-.74,1.47-1.42,2.67-2.24,2.48-.35-.08-.47-.51-.6-1a2.14,2.14,0,0,0-.76-1.36c-.89-.55-2,.8-2.76,2.25s-1.29,3.24-.5,4a1.48,1.48,0,0,0,1.36.24c.4-.06.78-.12,1,.22.5.82-.11,2.07-.89,3.51-.91,1.67-2.64,4.73-2.66,4.76a.49.49,0,0,1-.21.2.13.13,0,0,1-.18-.07A25.8,25.8,0,0,0,210.41,61c-1.51-2.09-2.28-1-2.84-.26a2.85,2.85,0,0,0-.39,1.19,7.45,7.45,0,0,1-.71,2.24c-.64,1.22-1.85,2.12-3,1.25s-1-2.57-.36-3.79a6.09,6.09,0,0,1,1.37-1.74,2.47,2.47,0,0,0,.72-.93c.34-1,.8-2.24-1.42-3a16.15,16.15,0,0,0-2.75-.73c-.07,0-.11-.07-.13-.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--team-icon--inject-83",
    d: "M66.52,57.88c4.52-2.62,8.19-9.62,8.19-15.65S71,33.43,66.52,36s-8.19,9.61-8.19,15.65S62,60.49,66.52,57.88Zm14.21,5.54c-.83-4.7-4.27-6.43-8.24-4.13L60.55,66.18c-4,2.3-7.41,8-8.24,13.65l-1.46,10c-.29,2,.75,3.09,2.13,2.29L80.06,76.45a5.17,5.17,0,0,0,2.13-4.74Zm4.29-23c3.25-1.87,5.89-6.91,5.89-11.24S88.27,22.9,85,24.78,79.14,31.69,79.14,36,81.77,42.35,85,40.47Zm10.22,3c-.61-3.33-3.07-4.59-5.93-2.94l-8.57,4.95c-2.44,1.41-4.56,4.54-5.51,7.92,4.17-1.27,7.63.87,8.91,5.6l10.41-6c1.64-.94,1.87-1.64,1.54-3.6ZM53.9,50.6c0-4.34-2.63-6.33-5.88-4.45s-5.89,6.91-5.89,11.24,2.64,6.32,5.89,4.45S53.9,54.93,53.9,50.6ZM37,83.49c-.33,2.34-.1,2.78,1.54,1.83l10.41-6C50.18,73.1,53.64,67,57.81,63.42c-1-2.29-3.07-3-5.51-1.56l-8.57,5c-2.86,1.65-5.32,5.75-5.93,9.79Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.87,383.79h0a3.34,3.34,0,0,1-3.37-.33,10.54,10.54,0,0,1-4.78-8.24,3.34,3.34,0,0,1,1.39-3.08h0l59.27-37.49h0c1.21-.82,2.94-.78,4.87.33A14.73,14.73,0,0,1,241,346.51c0,2.23-.82,3.75-2.13,4.4v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,375.22c0-3,2.12-4.27,4.76-2.76a10.54,10.54,0,0,1,4.78,8.24c0,3-2.12,4.28-4.76,2.76A10.54,10.54,0,0,1,168.72,375.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,388.14a6.34,6.34,0,0,1-2.89-5,2,2,0,0,1,.84-1.87h0l11.78-6.85h0a2,2,0,0,1,2,.2,6.32,6.32,0,0,1,2.89,5,2,2,0,0,1-.84,1.87l-11.77,6.85h0A2,2,0,0,1,161.72,388.14Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,388.14a6.34,6.34,0,0,1-2.89-5,2,2,0,0,1,.84-1.87h0l11.78-6.85h0a2,2,0,0,1,2,.2,6.32,6.32,0,0,1,2.89,5,2,2,0,0,1-.84,1.87l-11.77,6.85h0A2,2,0,0,1,161.72,388.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.25,378.66c-.43-.34-.88-.67-1.34-1l-6.21,3.61a35.62,35.62,0,0,1,6.91,5.41l5.68-3.3c-.15-.18-.29-.36-.45-.54A37.46,37.46,0,0,0,167.25,378.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72,374.4l61-37.47a12,12,0,0,0-2.44-1.94c-1.93-1.1-3.66-1.15-4.88-.33h0l-59.27,37.48a3.37,3.37,0,0,1,3.37.33A8.64,8.64,0,0,1,175.72,374.4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,398.75c0-.24,0-.43,0-.57s0-.46,0-.69a15.47,15.47,0,0,0-.16-1.67c0-.2-.07-.4-.11-.62a17.08,17.08,0,0,0-.56-2.27c-.06-.21-.13-.42-.2-.63-.2-.55-.42-1.11-.67-1.65a6.11,6.11,0,0,0-.27-.58l-.26-.52c-.13-.25-.25-.49-.4-.73s-.27-.48-.42-.73l-.46-.71a25.88,25.88,0,0,0-2.75-3.5,33.68,33.68,0,0,0-4.35-4,48.67,48.67,0,0,0-5.48-3.63c-21.4-12.22-55.9-12.22-77.05,0-.54.31-1,.61-1.55.93A42.9,42.9,0,0,0,75,381.15c-.48.43-.95.85-1.39,1.29a30.62,30.62,0,0,0-3.07,3.48c-.16.21-.32.43-.47.66s-.41.59-.6.89-.51.83-.75,1.24-.49.93-.71,1.4a4.72,4.72,0,0,0-.27.61,8.93,8.93,0,0,0-.35.85,4.88,4.88,0,0,0-.23.64,18.15,18.15,0,0,0-1,4.55c0,.17,0,.33,0,.49,0,.36,0,.72,0,1.07,0,1.32,0,7.32,0,8.42,0,8.08,5.32,16.18,16,22.37,21.28,12.29,55.78,12.29,77.05,0,10.75-6.2,16-14.33,15.89-22.44C175,405.75,175.07,400.72,175.05,398.75ZM84.93,381.58c9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35c8.4,4.78,13,10.78,13,16.89s-4.54,12-12.83,16.83c-9.37,5.42-22,8.4-35.47,8.4s-26.08-3-35.46-8.4c-8.36-4.83-13-10.86-13-17S76.73,386.32,84.93,381.58Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,398.75c0-.24,0-.43,0-.57s0-.46,0-.69a15.47,15.47,0,0,0-.16-1.67c0-.2-.07-.4-.11-.62a17.08,17.08,0,0,0-.56-2.27c-.06-.21-.13-.42-.2-.63-.2-.55-.42-1.11-.67-1.65a6.11,6.11,0,0,0-.27-.58l-.26-.52c-.13-.25-.25-.49-.4-.73s-.27-.48-.42-.73l-.46-.71a25.88,25.88,0,0,0-2.75-3.5,33.68,33.68,0,0,0-4.35-4,48.67,48.67,0,0,0-5.48-3.63c-21.4-12.22-55.9-12.22-77.05,0-.54.31-1,.61-1.55.93A42.9,42.9,0,0,0,75,381.15c-.48.43-.95.85-1.39,1.29a30.62,30.62,0,0,0-3.07,3.48c-.16.21-.32.43-.47.66s-.41.59-.6.89-.51.83-.75,1.24-.49.93-.71,1.4a4.72,4.72,0,0,0-.27.61,8.93,8.93,0,0,0-.35.85,4.88,4.88,0,0,0-.23.64,18.15,18.15,0,0,0-1,4.55c0,.17,0,.33,0,.49,0,.36,0,.72,0,1.07,0,1.32,0,7.32,0,8.42,0,8.08,5.32,16.18,16,22.37,21.28,12.29,55.78,12.29,77.05,0,10.75-6.2,16-14.33,15.89-22.44C175,405.75,175.07,400.72,175.05,398.75ZM84.93,381.58c9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35c8.4,4.78,13,10.78,13,16.89s-4.54,12-12.83,16.83c-9.37,5.42-22,8.4-35.47,8.4s-26.08-3-35.46-8.4c-8.36-4.83-13-10.86-13-17S76.73,386.32,84.93,381.58Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,398.75h-6.12c0,6.07-4.54,11.77-12.83,16.56-9.1,5.26-21.22,8.21-34.27,8.38v14.62c13.54-.17,27-3.23,37.33-9.2,10.75-6.2,16-14.33,15.89-22.44C175,405.75,175.07,400.72,175.05,398.75Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,398.18q0-.35,0-.69a15.47,15.47,0,0,0-.16-1.67c0-.2-.07-.4-.11-.62a17.08,17.08,0,0,0-.56-2.27c-.06-.21-.13-.42-.2-.63-.2-.55-.42-1.11-.67-1.65a6.11,6.11,0,0,0-.27-.58l-.26-.52c-.13-.25-.25-.49-.4-.73s-.27-.48-.42-.73l-.46-.71a25.88,25.88,0,0,0-2.75-3.5,35.12,35.12,0,0,0-4.35-4,48.67,48.67,0,0,0-5.48-3.63c-21.4-12.22-55.9-12.22-77.05,0-.54.31-1,.61-1.55.93A42.9,42.9,0,0,0,75,381.15c-.48.43-.95.85-1.39,1.29a30.62,30.62,0,0,0-3.07,3.48c-.16.21-.32.43-.47.66s-.41.59-.6.89-.51.83-.75,1.24-.49.93-.71,1.4a4.72,4.72,0,0,0-.27.61,8.93,8.93,0,0,0-.35.85,4.88,4.88,0,0,0-.23.64,18.15,18.15,0,0,0-1,4.55c0,.17,0,.33,0,.49,0,.36,0,.72,0,1.07,0,8.06,5.35,16.14,16,22.3,21.28,12.28,55.78,12.28,77.05,0,10.5-6.05,15.8-13.95,15.89-21.87C175.06,398.51,175.05,398.32,175.05,398.18Zm-19,17.13c-9.37,5.42-22,8.4-35.47,8.4s-26.08-3-35.46-8.4c-8.36-4.83-13-10.86-13-17s4.53-12,12.73-16.74c9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35c8.4,4.78,13,10.78,13,16.89S164.39,410.52,156.1,415.31Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.05,398.18q0-.35,0-.69a15.47,15.47,0,0,0-.16-1.67c0-.2-.07-.4-.11-.62a17.08,17.08,0,0,0-.56-2.27c-.06-.21-.13-.42-.2-.63-.2-.55-.42-1.11-.67-1.65a6.11,6.11,0,0,0-.27-.58l-.26-.52c-.13-.25-.25-.49-.4-.73s-.27-.48-.42-.73l-.46-.71a25.88,25.88,0,0,0-2.75-3.5,35.12,35.12,0,0,0-4.35-4,48.67,48.67,0,0,0-5.48-3.63c-21.4-12.22-55.9-12.22-77.05,0-.54.31-1,.61-1.55.93A42.9,42.9,0,0,0,75,381.15c-.48.43-.95.85-1.39,1.29a30.62,30.62,0,0,0-3.07,3.48c-.16.21-.32.43-.47.66s-.41.59-.6.89-.51.83-.75,1.24-.49.93-.71,1.4a4.72,4.72,0,0,0-.27.61,8.93,8.93,0,0,0-.35.85,4.88,4.88,0,0,0-.23.64,18.15,18.15,0,0,0-1,4.55c0,.17,0,.33,0,.49,0,.36,0,.72,0,1.07,0,8.06,5.35,16.14,16,22.3,21.28,12.28,55.78,12.28,77.05,0,10.5-6.05,15.8-13.95,15.89-21.87C175.06,398.51,175.05,398.32,175.05,398.18Zm-19,17.13c-9.37,5.42-22,8.4-35.47,8.4s-26.08-3-35.46-8.4c-8.36-4.83-13-10.86-13-17s4.53-12,12.73-16.74c9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35c8.4,4.78,13,10.78,13,16.89S164.39,410.52,156.1,415.31Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,398.48a12.06,12.06,0,0,1-.39,3.09c-1.27-5-5.65-9.87-12.65-13.85-9.44-5.39-22.08-8.35-35.59-8.35s-26,3-35.37,8.34c-6.82,3.92-11.09,8.69-12.34,13.66a12.21,12.21,0,0,1-.39-3.05c0-6.07,4.53-12,12.73-16.74,9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35C164.29,386.37,168.91,392.37,168.93,398.48Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,398.48a12.06,12.06,0,0,1-.39,3.09c-1.27-5-5.65-9.87-12.65-13.85-9.44-5.39-22.08-8.35-35.59-8.35s-26,3-35.37,8.34c-6.82,3.92-11.09,8.69-12.34,13.66a12.21,12.21,0,0,1-.39-3.05c0-6.07,4.53-12,12.73-16.74,9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35C164.29,386.37,168.91,392.37,168.93,398.48Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.83,400.08c-.72,5.5-5.17,10.87-12.73,15.23-9.37,5.42-22,8.4-35.47,8.4s-26.08-3-35.46-8.4c-7.66-4.42-12.16-9.85-12.87-15.44.71-5.53,5.13-10.87,12.63-15.2,9.32-5.38,21.88-8.34,35.37-8.34s26.15,3,35.59,8.35C163.6,389.07,168.13,394.49,168.83,400.08Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-83",
    d: "M422,416.14a4.13,4.13,0,0,1-4-3.31l-.67-3.57a45.14,45.14,0,0,1-4.55-1.12l-6.93,3.21a4.67,4.67,0,0,1-1.95.41,4.81,4.81,0,0,1-2.38-.61l-7.09-4.09a3.52,3.52,0,0,1-.3-6l3.72-2.67c-.18-.26-.35-.52-.5-.78l-8.67-.55a4,4,0,0,1-3.69-3.93v-5.28a4,4,0,0,1,3.69-3.93l8.67-.55c.15-.26.32-.52.5-.78l-3.72-2.67a3.57,3.57,0,0,1-1.53-3.08,3.61,3.61,0,0,1,1.83-2.92l7.09-4.09a4.86,4.86,0,0,1,2.38-.61,4.75,4.75,0,0,1,2,.42l6.92,3.21a42.6,42.6,0,0,1,4.55-1.13l.67-3.57a4.13,4.13,0,0,1,4-3.31h10.43a4.14,4.14,0,0,1,4,3.31l.67,3.57a41.83,41.83,0,0,1,4.54,1.13l6.94-3.21a4.64,4.64,0,0,1,2-.42,4.84,4.84,0,0,1,2.38.61l7.09,4.1a3.51,3.51,0,0,1,.3,6l-3.72,2.67c.18.26.34.52.5.78l8.67.55a4,4,0,0,1,3.69,3.93v5.28a4,4,0,0,1-3.69,3.93l-8.67.55c-.16.26-.32.52-.5.78l3.72,2.67a3.52,3.52,0,0,1-.3,6l-7.09,4.09a4.86,4.86,0,0,1-2.38.61h0a4.67,4.67,0,0,1-2-.41l-6.94-3.21a44.29,44.29,0,0,1-4.54,1.12l-.67,3.57a4.13,4.13,0,0,1-4,3.31Zm5.22-32.43a21.63,21.63,0,0,0-10.49,2.46c-2.2,1.27-3.46,2.85-3.46,4.32s1.26,3.05,3.46,4.32a23.57,23.57,0,0,0,21,0c2.2-1.27,3.46-2.84,3.46-4.32s-1.26-3.05-3.46-4.32A21.59,21.59,0,0,0,427.17,383.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.45,370.37l-7.09-4.09a1.88,1.88,0,0,0-1.57-.07l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H422a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.74,2.74,0,0,1-1.65-.1l-7.19-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.59.59,0,0,0-.33.49h0l0,6.14h0a.6.6,0,0,0,.28.48l3.27,2.35a1.57,1.57,0,0,1-.81.33l-9.45.6a1,1,0,0,0-.88.94v4h0v7.4a1,1,0,0,0,.88.94l9.46.59a1.64,1.64,0,0,1,.82.35l-3.25,2.34a.57.57,0,0,0-.28.47h0l0,6.16h0a.59.59,0,0,0,.33.49l7.1,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.63,2.63,0,0,1,1.64-.1,43.25,43.25,0,0,0,5.58,1.33,1.34,1.34,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1,43.25,43.25,0,0,0,5.58-1.33,2.74,2.74,0,0,1,1.65.1l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.09-4.09a.57.57,0,0,0,.33-.48h0l0-6.17h0a.57.57,0,0,0-.28-.47L455.23,395a1.68,1.68,0,0,1,.81-.34l9.45-.59a1,1,0,0,0,.89-.94V381.7a1,1,0,0,0-.88-.94l-9.45-.6a1.51,1.51,0,0,1-.82-.34l3.24-2.34a.57.57,0,0,0,.28-.47h0l0-6.16h0A.57.57,0,0,0,458.45,370.37ZM410.56,386.3c.51-1.69,2-3.36,4.62-4.85,6.62-3.82,17.35-3.82,24,0a10.92,10.92,0,0,1,4.72,4.52c-.56,1.94-2.13,3.79-4.72,5.29-6.62,3.82-17.35,3.82-24,0A9.8,9.8,0,0,1,410.56,386.3Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.45,370.37l-7.09-4.09a1.88,1.88,0,0,0-1.57-.07l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H422a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.74,2.74,0,0,1-1.65-.1l-7.19-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.59.59,0,0,0-.33.49h0l0,6.14h0a.6.6,0,0,0,.28.48l3.27,2.35a1.57,1.57,0,0,1-.81.33l-9.45.6a1,1,0,0,0-.88.94v4h0v7.4a1,1,0,0,0,.88.94l9.46.59a1.64,1.64,0,0,1,.82.35l-3.25,2.34a.57.57,0,0,0-.28.47h0l0,6.16h0a.59.59,0,0,0,.33.49l7.1,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.63,2.63,0,0,1,1.64-.1,43.25,43.25,0,0,0,5.58,1.33,1.34,1.34,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1,43.25,43.25,0,0,0,5.58-1.33,2.74,2.74,0,0,1,1.65.1l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.09-4.09a.57.57,0,0,0,.33-.48h0l0-6.17h0a.57.57,0,0,0-.28-.47L455.23,395a1.68,1.68,0,0,1,.81-.34l9.45-.59a1,1,0,0,0,.89-.94V381.7a1,1,0,0,0-.88-.94l-9.45-.6a1.51,1.51,0,0,1-.82-.34l3.24-2.34a.57.57,0,0,0,.28-.47h0l0-6.16h0A.57.57,0,0,0,458.45,370.37ZM410.56,386.3c.51-1.69,2-3.36,4.62-4.85,6.62-3.82,17.35-3.82,24,0a10.92,10.92,0,0,1,4.72,4.52c-.56,1.94-2.13,3.79-4.72,5.29-6.62,3.82-17.35,3.82-24,0A9.8,9.8,0,0,1,410.56,386.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.55,389.36a1.77,1.77,0,0,0-1.28-.85l-9.45-.59a1,1,0,0,1-.88-.94v6.14a1,1,0,0,0,.88.95l9.46.59a1.56,1.56,0,0,1,.83.35l2.36-1.71a.74.74,0,0,0,.11-1.15A14.19,14.19,0,0,1,399.55,389.36Zm-4-12.36h0a.6.6,0,0,0,.28.47l3.27,2.35a1.75,1.75,0,0,0,.47-.51,14.19,14.19,0,0,1,2-2.79.74.74,0,0,0-.11-1.15l-5.62-4.05a.7.7,0,0,1-.29-.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.15,377.42c-6.62-3.82-17.35-3.82-24,0-4.18,2.42-5.72,5.78-4.62,8.89.5-1.7,2-3.36,4.62-4.86,6.62-3.83,17.35-3.82,24,0,2.43,1.4,4,2.93,4.74,4.52C444.76,383,443.17,379.75,439.15,377.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.39,387.1a1,1,0,0,1-.88.82l-9.45.59a1.43,1.43,0,0,0-.48.13v6.16a1.45,1.45,0,0,1,.47-.13l9.45-.61a1,1,0,0,0,.89-.93Zm-7.61-16.25h0a.46.46,0,0,1,0,.19.44.44,0,0,1-.11.18.69.69,0,0,1-.13.11l-5.62,4.05a.33.33,0,0,0-.14.12.84.84,0,0,0-.18.35.59.59,0,0,0,0,.23.37.37,0,0,0,0,.12.92.92,0,0,0,.19.33l.11.12a14.69,14.69,0,0,1,1.9,2.66,1.94,1.94,0,0,0,.45.51l3.25-2.33a.6.6,0,0,0,.28-.48h0Zm0,27a.61.61,0,0,1-.33.44l-7.1,4.09a1.9,1.9,0,0,1-1.1.2v6.14a1.89,1.89,0,0,0,1.1-.19l7.09-4.09a.57.57,0,0,0,.33-.47ZM412.44,399a2.18,2.18,0,0,0-.71.17l-7.19,3.33a1.44,1.44,0,0,1-.64.14v6.14a1.66,1.66,0,0,0,.64-.13l7.19-3.33a2.4,2.4,0,0,1,.7-.17Zm20.82,7.55a1.12,1.12,0,0,1-.88.47H422a1.06,1.06,0,0,1-.64-.23v6.15a1.13,1.13,0,0,0,.63.23h10.43a1.1,1.1,0,0,0,.91-.53Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.39,387.1a1,1,0,0,1-.88.82l-9.45.59a1.43,1.43,0,0,0-.48.13v6.16a1.45,1.45,0,0,1,.47-.13l9.45-.61a1,1,0,0,0,.89-.93Zm-7.61-16.25h0a.46.46,0,0,1,0,.19.44.44,0,0,1-.11.18.69.69,0,0,1-.13.11l-5.62,4.05a.33.33,0,0,0-.14.12.84.84,0,0,0-.18.35.59.59,0,0,0,0,.23.37.37,0,0,0,0,.12.92.92,0,0,0,.19.33l.11.12a14.69,14.69,0,0,1,1.9,2.66,1.94,1.94,0,0,0,.45.51l3.25-2.33a.6.6,0,0,0,.28-.48h0Zm0,27a.61.61,0,0,1-.33.44l-7.1,4.09a1.9,1.9,0,0,1-1.1.2v6.14a1.89,1.89,0,0,0,1.1-.19l7.09-4.09a.57.57,0,0,0,.33-.47ZM412.44,399a2.18,2.18,0,0,0-.71.17l-7.19,3.33a1.44,1.44,0,0,1-.64.14v6.14a1.66,1.66,0,0,0,.64-.13l7.19-3.33a2.4,2.4,0,0,1,.7-.17Zm20.82,7.55a1.12,1.12,0,0,1-.88.47H422a1.06,1.06,0,0,1-.64-.23v6.15a1.13,1.13,0,0,0,.63.23h10.43a1.1,1.1,0,0,0,.91-.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.79,366.21l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H422a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.74,2.74,0,0,1-1.65-.1l-7.19-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.53.53,0,0,0-.05,1l5.62,4.05a.74.74,0,0,1,.11,1.15,14.19,14.19,0,0,0-2,2.79,1.75,1.75,0,0,1-1.28.84l-9.45.6a1,1,0,0,0-.88.94V387a1,1,0,0,0,.88.94l9.45.6a1.73,1.73,0,0,1,1.28.84,14.19,14.19,0,0,0,2,2.79.74.74,0,0,1-.11,1.15l-5.62,4.05a.53.53,0,0,0,.05,1L403,402.4a1.88,1.88,0,0,0,1.57.07l7.19-3.33a2.74,2.74,0,0,1,1.65-.1,43.25,43.25,0,0,0,5.58,1.33,1.36,1.36,0,0,1,1,1l.9,4.74A1.11,1.11,0,0,0,422,407h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1A43.25,43.25,0,0,0,441,399a2.74,2.74,0,0,1,1.65.1l7.19,3.33a1.88,1.88,0,0,0,1.57-.07l7.09-4.09a.53.53,0,0,0,.05-1l-5.62-4.05a.74.74,0,0,1-.11-1.15,14.19,14.19,0,0,0,2-2.79,1.73,1.73,0,0,1,1.28-.84l9.45-.6a1,1,0,0,0,.88-.94V381.7a1,1,0,0,0-.88-.94l-9.45-.6a1.73,1.73,0,0,1-1.28-.84,14.19,14.19,0,0,0-2-2.79.74.74,0,0,1,.11-1.15l5.62-4.05a.53.53,0,0,0-.05-1l-7.09-4.09A1.88,1.88,0,0,0,449.79,366.21Zm-10.64,11.21c6.62,3.82,6.62,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S432.53,373.6,439.15,377.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.79,366.21l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H422a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.74,2.74,0,0,1-1.65-.1l-7.19-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.53.53,0,0,0-.05,1l5.62,4.05a.74.74,0,0,1,.11,1.15,14.19,14.19,0,0,0-2,2.79,1.75,1.75,0,0,1-1.28.84l-9.45.6a1,1,0,0,0-.88.94V387a1,1,0,0,0,.88.94l9.45.6a1.73,1.73,0,0,1,1.28.84,14.19,14.19,0,0,0,2,2.79.74.74,0,0,1-.11,1.15l-5.62,4.05a.53.53,0,0,0,.05,1L403,402.4a1.88,1.88,0,0,0,1.57.07l7.19-3.33a2.74,2.74,0,0,1,1.65-.1,43.25,43.25,0,0,0,5.58,1.33,1.36,1.36,0,0,1,1,1l.9,4.74A1.11,1.11,0,0,0,422,407h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1A43.25,43.25,0,0,0,441,399a2.74,2.74,0,0,1,1.65.1l7.19,3.33a1.88,1.88,0,0,0,1.57-.07l7.09-4.09a.53.53,0,0,0,.05-1l-5.62-4.05a.74.74,0,0,1-.11-1.15,14.19,14.19,0,0,0,2-2.79,1.73,1.73,0,0,1,1.28-.84l9.45-.6a1,1,0,0,0,.88-.94V381.7a1,1,0,0,0-.88-.94l-9.45-.6a1.73,1.73,0,0,1-1.28-.84,14.19,14.19,0,0,0-2-2.79.74.74,0,0,1,.11-1.15l5.62-4.05a.53.53,0,0,0-.05-1l-7.09-4.09A1.88,1.88,0,0,0,449.79,366.21Zm-10.64,11.21c6.62,3.82,6.62,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S432.53,373.6,439.15,377.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.38,407.34H422a1.45,1.45,0,0,1-1.39-1.16l-.9-4.74a1,1,0,0,0-.76-.73,43.7,43.7,0,0,1-5.63-1.33,2.2,2.2,0,0,0-1.39.08l-7.19,3.33a2.27,2.27,0,0,1-1.89-.09l-7.09-4.09a.93.93,0,0,1-.51-.75,1,1,0,0,1,.43-.8l5.62-4a.4.4,0,0,0,.18-.29.45.45,0,0,0-.13-.35,14.37,14.37,0,0,1-2.06-2.85,1.42,1.42,0,0,0-1-.67l-9.45-.59a1.32,1.32,0,0,1-1.21-1.29V381.7a1.3,1.3,0,0,1,1.21-1.28l9.45-.6a1.42,1.42,0,0,0,1-.67,14.37,14.37,0,0,1,2.06-2.85.45.45,0,0,0,.13-.35.4.4,0,0,0-.18-.29l-5.62-4a.88.88,0,0,1,.08-1.55L402.8,366a2.27,2.27,0,0,1,1.89-.09l7.19,3.33a2.23,2.23,0,0,0,1.4.08A43.15,43.15,0,0,1,418.9,368a1,1,0,0,0,.76-.73l.9-4.74a1.45,1.45,0,0,1,1.39-1.16h10.43a1.45,1.45,0,0,1,1.39,1.16l.9,4.73a1,1,0,0,0,.76.74,43.54,43.54,0,0,1,5.62,1.33,2.23,2.23,0,0,0,1.4-.08l7.19-3.33a2.27,2.27,0,0,1,1.89.09l7.09,4.09a1,1,0,0,1,.51.75.92.92,0,0,1-.43.79l-5.62,4.05a.4.4,0,0,0-.18.29.45.45,0,0,0,.13.35,13.92,13.92,0,0,1,2.05,2.85,1.44,1.44,0,0,0,1,.67l9.45.59a1.32,1.32,0,0,1,1.21,1.29V387a1.3,1.3,0,0,1-1.21,1.28l-9.45.6a1.44,1.44,0,0,0-1,.67,13.92,13.92,0,0,1-2.05,2.85.45.45,0,0,0-.13.35.4.4,0,0,0,.18.29l5.62,4a.88.88,0,0,1-.08,1.55l-7.09,4.09a2.27,2.27,0,0,1-1.89.09l-7.19-3.33a2.23,2.23,0,0,0-1.4-.08,43.54,43.54,0,0,1-5.62,1.33,1,1,0,0,0-.76.73l-.9,4.74A1.45,1.45,0,0,1,432.38,407.34Zm-19.66-8.73a2.59,2.59,0,0,1,.76.1A42.31,42.31,0,0,0,419,400a1.71,1.71,0,0,1,1.32,1.28l.9,4.74a.77.77,0,0,0,.71.59h10.43a.77.77,0,0,0,.71-.59l.9-4.74a1.68,1.68,0,0,1,1.32-1.28,42.31,42.31,0,0,0,5.54-1.32,3,3,0,0,1,1.89.12l7.19,3.33a1.6,1.6,0,0,0,1.25-.06l7.1-4.09c.09-.06.15-.13.15-.19s-.05-.13-.14-.19l-5.62-4.05a1.07,1.07,0,0,1-.46-.78,1.12,1.12,0,0,1,.3-.89,13.66,13.66,0,0,0,2-2.71,2.1,2.1,0,0,1,1.56-1l9.46-.6A.61.61,0,0,0,466,387V381.7a.61.61,0,0,0-.55-.59l-9.46-.6a2.1,2.1,0,0,1-1.56-1,13.66,13.66,0,0,0-2-2.71,1.12,1.12,0,0,1-.3-.89,1.09,1.09,0,0,1,.46-.79l5.62-4c.09-.06.15-.14.14-.2s-.06-.12-.15-.18l-7.1-4.09a1.55,1.55,0,0,0-1.25-.06l-7.19,3.33a3,3,0,0,1-1.89.12,42.31,42.31,0,0,0-5.54-1.32,1.68,1.68,0,0,1-1.32-1.29l-.9-4.73a.77.77,0,0,0-.71-.59H422a.77.77,0,0,0-.71.59l-.9,4.73a1.71,1.71,0,0,1-1.32,1.29,42.31,42.31,0,0,0-5.54,1.32,3,3,0,0,1-1.89-.12l-7.19-3.33a1.55,1.55,0,0,0-1.25.06l-7.1,4.09c-.09.06-.15.13-.15.18s.05.13.14.2l5.62,4a1.14,1.14,0,0,1,.46.79,1.09,1.09,0,0,1-.31.89,13.6,13.6,0,0,0-1.95,2.71,2.1,2.1,0,0,1-1.57,1l-9.45.6a.61.61,0,0,0-.56.59V387a.61.61,0,0,0,.56.59l9.45.6a2.1,2.1,0,0,1,1.57,1,13.6,13.6,0,0,0,1.95,2.71,1.1,1.1,0,0,1-.15,1.67L396,397.63c-.09.06-.15.14-.14.19s.06.13.15.19l7.1,4.09a1.59,1.59,0,0,0,1.25.06l7.19-3.33A2.68,2.68,0,0,1,412.72,398.61Zm14.44-4.15a24.78,24.78,0,0,1-12.15-2.9c-3.32-1.91-5.14-4.48-5.14-7.22s1.82-5.31,5.14-7.22c6.7-3.87,17.61-3.87,24.31,0h0c3.31,1.91,5.14,4.48,5.14,7.22s-1.82,5.31-5.14,7.22A24.79,24.79,0,0,1,427.16,394.46Zm0-19.56a24.18,24.18,0,0,0-11.81,2.82c-3.08,1.79-4.78,4.14-4.78,6.62s1.7,4.83,4.78,6.62c6.52,3.76,17.11,3.76,23.62,0,3.09-1.79,4.79-4.14,4.79-6.62s-1.7-4.83-4.79-6.62A24.13,24.13,0,0,0,427.16,374.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-83",
    d: "M362.09,378.08l-.44,0-6.15-.65a4.07,4.07,0,0,1-3.63-4.54l.12-.95q-.78-.29-1.53-.6s0,0,0,0h-.07l-4.67,1.47a4.78,4.78,0,0,1-1.42.21,5.25,5.25,0,0,1-3.29-1.14l-3.14-2.62a3.65,3.65,0,0,1,.71-6.18l1.07-.53-2.89-.49a3.94,3.94,0,0,1-3.11-5.09l.86-2.72a4.52,4.52,0,0,1,4.23-3.1l5.23.2-.67-.71a3.69,3.69,0,0,1,1.34-6.05l4.92-2a5,5,0,0,1,1.84-.34,5.29,5.29,0,0,1,2.86.82l3.19,2.12h0c.92-.16,1.86-.28,2.8-.37l.95-1.85a4.75,4.75,0,0,1,4.13-2.5,3.15,3.15,0,0,1,.44,0l6.15.64a4,4,0,0,1,2.77,1.51,4.09,4.09,0,0,1,.86,3l-.12.95c.52.19,1,.4,1.53.61,0,0,0,0,0,0h.07l4.67-1.46a4.74,4.74,0,0,1,1.42-.22,5.2,5.2,0,0,1,3.28,1.14l3.15,2.62a3.65,3.65,0,0,1-.72,6.18l-1.06.53,2.89.5a3.93,3.93,0,0,1,2.72,1.83,4,4,0,0,1,.39,3.25l-.86,2.72a4.53,4.53,0,0,1-4.23,3.11l-5.24-.21.68.71a3.7,3.7,0,0,1-1.34,6.05l-4.92,2a4.82,4.82,0,0,1-1.84.34,5.21,5.21,0,0,1-2.86-.82l-3.2-2.12h0c-.91.16-1.85.28-2.8.37l-.95,1.85A4.73,4.73,0,0,1,362.09,378.08Zm1.63-22.58a15.23,15.23,0,0,0-5.58,1c-2.16.87-3.05,2-3.16,2.65s.58,1.36,1,1.71c1.64,1.37,4.62,2.23,7.75,2.23a15.23,15.23,0,0,0,5.58-1c2.16-.87,3.05-2,3.16-2.65s-.59-1.36-1-1.71C369.82,356.35,366.85,355.5,363.72,355.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,343.93a1.33,1.33,0,0,1-.92-1.39l.28-2.34a1.08,1.08,0,0,0-1-1.2l-6.15-.64a1.71,1.71,0,0,0-1.59.86l-1.23,2.38a2.12,2.12,0,0,1-1.59,1c-1.07.08-2.14.22-3.19.4a3.11,3.11,0,0,1-2-.4l-3.32-2.2a2.35,2.35,0,0,0-1.92-.2l-4.93,2a.7.7,0,0,0-.5.63h0v.06h0v5h0a.84.84,0,0,0,.24.56l.29.3a2.54,2.54,0,0,1-1.35.42l-5.63-.22a1.5,1.5,0,0,0-1.42,1l-.85,2.72a.93.93,0,0,0,0,.33h0v5.08h0a.92.92,0,0,0,.8.88l4.36.75-1.7.85a.71.71,0,0,0-.45.62h0v5.08h0a.8.8,0,0,0,.31.56l3.14,2.62a2.27,2.27,0,0,0,1.89.37l4.79-1.5a3.36,3.36,0,0,1,2,.13,25.21,25.21,0,0,0,2.57.95,1.34,1.34,0,0,1,.63.44v3.43h0a1.07,1.07,0,0,0,1,1.06L362,375a1.73,1.73,0,0,0,1.59-.86l1.22-2.39a2.17,2.17,0,0,1,1.6-1c1.07-.08,2.14-.21,3.18-.39a3.12,3.12,0,0,1,2,.39l3.31,2.2a2.3,2.3,0,0,0,1.93.2l4.93-2a.71.71,0,0,0,.5-.66h0v-5.08h0a.81.81,0,0,0-.25-.54l-.28-.31a2.7,2.7,0,0,1,1.35-.42l5.63.23a1.51,1.51,0,0,0,1.42-1l.85-2.72a1.15,1.15,0,0,0,0-.31h0v-5.06h0a.92.92,0,0,0-.78-.94l-4.36-.74,1.7-.86a.68.68,0,0,0,.44-.62h0v-5.05h0a.74.74,0,0,0-.3-.59l-3.15-2.61a2.21,2.21,0,0,0-1.88-.38L377.85,345a3.39,3.39,0,0,1-2-.14A25,25,0,0,0,373.25,343.93Zm-20.43,12.74a9.29,9.29,0,0,1,4.21-3c5.33-2.14,12.66-1.37,16.36,1.71a6.65,6.65,0,0,1,1.25,1.33,9.12,9.12,0,0,1-4.21,3.05c-5.33,2.14-12.66,1.37-16.36-1.71A6.49,6.49,0,0,1,352.82,356.67Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,343.93a1.33,1.33,0,0,1-.92-1.39l.28-2.34a1.08,1.08,0,0,0-1-1.2l-6.15-.64a1.71,1.71,0,0,0-1.59.86l-1.23,2.38a2.12,2.12,0,0,1-1.59,1c-1.07.08-2.14.22-3.19.4a3.11,3.11,0,0,1-2-.4l-3.32-2.2a2.35,2.35,0,0,0-1.92-.2l-4.93,2a.7.7,0,0,0-.5.63h0v.06h0v5h0a.84.84,0,0,0,.24.56l.29.3a2.54,2.54,0,0,1-1.35.42l-5.63-.22a1.5,1.5,0,0,0-1.42,1l-.85,2.72a.93.93,0,0,0,0,.33h0v5.08h0a.92.92,0,0,0,.8.88l4.36.75-1.7.85a.71.71,0,0,0-.45.62h0v5.08h0a.8.8,0,0,0,.31.56l3.14,2.62a2.27,2.27,0,0,0,1.89.37l4.79-1.5a3.36,3.36,0,0,1,2,.13,25.21,25.21,0,0,0,2.57.95,1.34,1.34,0,0,1,.63.44v3.43h0a1.07,1.07,0,0,0,1,1.06L362,375a1.73,1.73,0,0,0,1.59-.86l1.22-2.39a2.17,2.17,0,0,1,1.6-1c1.07-.08,2.14-.21,3.18-.39a3.12,3.12,0,0,1,2,.39l3.31,2.2a2.3,2.3,0,0,0,1.93.2l4.93-2a.71.71,0,0,0,.5-.66h0v-5.08h0a.81.81,0,0,0-.25-.54l-.28-.31a2.7,2.7,0,0,1,1.35-.42l5.63.23a1.51,1.51,0,0,0,1.42-1l.85-2.72a1.15,1.15,0,0,0,0-.31h0v-5.06h0a.92.92,0,0,0-.78-.94l-4.36-.74,1.7-.86a.68.68,0,0,0,.44-.62h0v-5.05h0a.74.74,0,0,0-.3-.59l-3.15-2.61a2.21,2.21,0,0,0-1.88-.38L377.85,345a3.39,3.39,0,0,1-2-.14A25,25,0,0,0,373.25,343.93Zm-20.43,12.74a9.29,9.29,0,0,1,4.21-3c5.33-2.14,12.66-1.37,16.36,1.71a6.65,6.65,0,0,1,1.25,1.33,9.12,9.12,0,0,1-4.21,3.05c-5.33,2.14-12.66,1.37-16.36-1.71A6.49,6.49,0,0,1,352.82,356.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93,356.1a1.87,1.87,0,0,0-1.31-1.25l-5.35-.91a.91.91,0,0,1-.79-.84v5a.92.92,0,0,0,.79.88l4.36.75,2.26-1.13a1.07,1.07,0,0,0,.45-1.45A6.31,6.31,0,0,1,343.93,356.1Zm1.31-8.17h0a.86.86,0,0,0,.24.55l.29.31a2.53,2.53,0,0,0,.47-.36,11.19,11.19,0,0,1,1.34-1.2,1,1,0,0,0,.14-1.44l-2.24-2.38a.82.82,0,0,1-.24-.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,348.57c-4.61,1.84-6.23,5.24-4.2,8.11a9.09,9.09,0,0,1,4.19-3.05c5.34-2.13,12.67-1.37,16.37,1.71a6.65,6.65,0,0,1,1.25,1.33c1.42-2,1.09-4.45-1.24-6.4C369.69,347.19,362.37,346.43,357,348.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29,366.09a1.77,1.77,0,0,0-.51.59l-1.23,2.39a1.72,1.72,0,0,1-.91.76v5.07a1.68,1.68,0,0,0,.91-.76l1.23-2.39a1.67,1.67,0,0,1,.52-.58Zm16.93-.67h0a.7.7,0,0,1-.51.66l-4.91,2a2.2,2.2,0,0,1-1.3,0v5.07a2.24,2.24,0,0,0,1.29-.05l4.93-2a.73.73,0,0,0,.51-.66Zm-32.67-2.13-4.73,1.49a2.1,2.1,0,0,1-1.19,0v5.05a2.11,2.11,0,0,0,1.19,0l4.73-1.48Zm41.44-8a1,1,0,0,1-.05.3l-.85,2.72a1.5,1.5,0,0,1-1.42,1l-5.62-.22a2.33,2.33,0,0,0-.88.17v5.07a2.15,2.15,0,0,1,.87-.18l5.63.23a1.52,1.52,0,0,0,1.42-1l.85-2.72a.87.87,0,0,0,.05-.31Zm-3-8.2a1.36,1.36,0,0,1,0,.17.62.62,0,0,1-.17.26,1.8,1.8,0,0,1-.25.18l-3.95,2a.61.61,0,0,0-.24.17.92.92,0,0,0-.27.41,1.29,1.29,0,0,0-.06.4,1.62,1.62,0,0,0,0,.2,1.43,1.43,0,0,0,.09.27,7.18,7.18,0,0,1,.4,1.06,1.83,1.83,0,0,0,1.31,1.26l1,.16,1.7-.84a.72.72,0,0,0,.44-.63h0Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29,366.09a1.77,1.77,0,0,0-.51.59l-1.23,2.39a1.72,1.72,0,0,1-.91.76v5.07a1.68,1.68,0,0,0,.91-.76l1.23-2.39a1.67,1.67,0,0,1,.52-.58Zm16.93-.67h0a.7.7,0,0,1-.51.66l-4.91,2a2.2,2.2,0,0,1-1.3,0v5.07a2.24,2.24,0,0,0,1.29-.05l4.93-2a.73.73,0,0,0,.51-.66Zm-32.67-2.13-4.73,1.49a2.1,2.1,0,0,1-1.19,0v5.05a2.11,2.11,0,0,0,1.19,0l4.73-1.48Zm41.44-8a1,1,0,0,1-.05.3l-.85,2.72a1.5,1.5,0,0,1-1.42,1l-5.62-.22a2.33,2.33,0,0,0-.88.17v5.07a2.15,2.15,0,0,1,.87-.18l5.63.23a1.52,1.52,0,0,0,1.42-1l.85-2.72a.87.87,0,0,0,.05-.31Zm-3-8.2a1.36,1.36,0,0,1,0,.17.62.62,0,0,1-.17.26,1.8,1.8,0,0,1-.25.18l-3.95,2a.61.61,0,0,0-.24.17.92.92,0,0,0-.27.41,1.29,1.29,0,0,0-.06.4,1.62,1.62,0,0,0,0,.2,1.43,1.43,0,0,0,.09.27,7.18,7.18,0,0,1,.4,1.06,1.83,1.83,0,0,0,1.31,1.26l1,.16,1.7-.84a.72.72,0,0,0,.44-.63h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.64,343.51l-4.79,1.5a3.39,3.39,0,0,1-2-.14,25,25,0,0,0-2.56-.94,1.33,1.33,0,0,1-.92-1.39l.28-2.34a1.08,1.08,0,0,0-1-1.2l-6.15-.64a1.71,1.71,0,0,0-1.59.86l-1.23,2.38a2.12,2.12,0,0,1-1.59,1c-1.07.08-2.14.22-3.19.4a3.11,3.11,0,0,1-2-.4l-3.32-2.2a2.35,2.35,0,0,0-1.92-.2l-4.93,2a.69.69,0,0,0-.26,1.2l2.23,2.38a1,1,0,0,1-.14,1.44,12,12,0,0,0-1.34,1.2,2.75,2.75,0,0,1-1.82.77l-5.63-.22a1.5,1.5,0,0,0-1.42,1l-.85,2.72a.93.93,0,0,0,.75,1.23l5.35.91a1.85,1.85,0,0,1,1.31,1.26,6.54,6.54,0,0,0,.4,1.06,1.07,1.07,0,0,1-.45,1.45l-3.95,2a.66.66,0,0,0-.14,1.19l3.14,2.62a2.24,2.24,0,0,0,1.89.37l4.79-1.5a3.39,3.39,0,0,1,2,.13,24.18,24.18,0,0,0,2.56.95,1.33,1.33,0,0,1,.92,1.39l-.28,2.34a1.08,1.08,0,0,0,1,1.2l6.15.64a1.73,1.73,0,0,0,1.59-.86l1.23-2.39a2.15,2.15,0,0,1,1.59-1c1.07-.08,2.14-.21,3.19-.39a3,3,0,0,1,2,.4l3.31,2.19a2.3,2.3,0,0,0,1.93.2l4.93-2a.69.69,0,0,0,.26-1.2l-2.23-2.38a.94.94,0,0,1,.14-1.44,14.4,14.4,0,0,0,1.34-1.2,2.81,2.81,0,0,1,1.82-.78l5.63.23a1.5,1.5,0,0,0,1.42-1l.85-2.72a.93.93,0,0,0-.75-1.23l-5.35-.91a1.85,1.85,0,0,1-1.31-1.26,7.18,7.18,0,0,0-.4-1.06,1.07,1.07,0,0,1,.45-1.45l3.95-2a.66.66,0,0,0,.14-1.19l-3.15-2.61A2.18,2.18,0,0,0,382.64,343.51Zm-9.25,6.76c3.7,3.08,2.38,7.31-3,9.45s-12.66,1.37-16.36-1.71-2.38-7.31,3-9.45S369.69,347.19,373.39,350.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.64,343.51l-4.79,1.5a3.39,3.39,0,0,1-2-.14,25,25,0,0,0-2.56-.94,1.33,1.33,0,0,1-.92-1.39l.28-2.34a1.08,1.08,0,0,0-1-1.2l-6.15-.64a1.71,1.71,0,0,0-1.59.86l-1.23,2.38a2.12,2.12,0,0,1-1.59,1c-1.07.08-2.14.22-3.19.4a3.11,3.11,0,0,1-2-.4l-3.32-2.2a2.35,2.35,0,0,0-1.92-.2l-4.93,2a.69.69,0,0,0-.26,1.2l2.23,2.38a1,1,0,0,1-.14,1.44,12,12,0,0,0-1.34,1.2,2.75,2.75,0,0,1-1.82.77l-5.63-.22a1.5,1.5,0,0,0-1.42,1l-.85,2.72a.93.93,0,0,0,.75,1.23l5.35.91a1.85,1.85,0,0,1,1.31,1.26,6.54,6.54,0,0,0,.4,1.06,1.07,1.07,0,0,1-.45,1.45l-3.95,2a.66.66,0,0,0-.14,1.19l3.14,2.62a2.24,2.24,0,0,0,1.89.37l4.79-1.5a3.39,3.39,0,0,1,2,.13,24.18,24.18,0,0,0,2.56.95,1.33,1.33,0,0,1,.92,1.39l-.28,2.34a1.08,1.08,0,0,0,1,1.2l6.15.64a1.73,1.73,0,0,0,1.59-.86l1.23-2.39a2.15,2.15,0,0,1,1.59-1c1.07-.08,2.14-.21,3.19-.39a3,3,0,0,1,2,.4l3.31,2.19a2.3,2.3,0,0,0,1.93.2l4.93-2a.69.69,0,0,0,.26-1.2l-2.23-2.38a.94.94,0,0,1,.14-1.44,14.4,14.4,0,0,0,1.34-1.2,2.81,2.81,0,0,1,1.82-.78l5.63.23a1.5,1.5,0,0,0,1.42-1l.85-2.72a.93.93,0,0,0-.75-1.23l-5.35-.91a1.85,1.85,0,0,1-1.31-1.26,7.18,7.18,0,0,0-.4-1.06,1.07,1.07,0,0,1,.45-1.45l3.95-2a.66.66,0,0,0,.14-1.19l-3.15-2.61A2.18,2.18,0,0,0,382.64,343.51Zm-9.25,6.76c3.7,3.08,2.38,7.31-3,9.45s-12.66,1.37-16.36-1.71-2.38-7.31,3-9.45S369.69,347.19,373.39,350.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.09,370.37h-.17l-6.16-.64a1.56,1.56,0,0,1-1-.56,1.53,1.53,0,0,1-.32-1.13l.29-2.33a.92.92,0,0,0-.63-.93,26.65,26.65,0,0,1-2.61-1,2.94,2.94,0,0,0-1.73-.12l-4.79,1.5a2.64,2.64,0,0,1-2.29-.45l-3.14-2.62a1.15,1.15,0,0,1-.47-1,1.17,1.17,0,0,1,.68-.89l3.95-2a.64.64,0,0,0,.26-.88,8.57,8.57,0,0,1-.43-1.12,1.39,1.39,0,0,0-1-1l-5.35-.92a1.35,1.35,0,0,1-1.09-1.78l.85-2.72a1.94,1.94,0,0,1,1.85-1.3l5.62.22a2.33,2.33,0,0,0,1.5-.64,12,12,0,0,1,1.39-1.24.59.59,0,0,0,.24-.41.53.53,0,0,0-.15-.4l-2.24-2.37a1.23,1.23,0,0,1-.34-1.08,1.19,1.19,0,0,1,.76-.82l4.93-2a2.78,2.78,0,0,1,2.32.24l3.31,2.2a2.78,2.78,0,0,0,1.68.34c1-.19,2.13-.32,3.23-.41a1.72,1.72,0,0,0,1.24-.8l1.23-2.39a2.15,2.15,0,0,1,2-1.09l6.16.64a1.5,1.5,0,0,1,1,.56,1.56,1.56,0,0,1,.32,1.12l-.29,2.34a.94.94,0,0,0,.62.93,22.81,22.81,0,0,1,2.61,1,3,3,0,0,0,1.74.12l4.79-1.51a2.68,2.68,0,0,1,2.29.46l3.14,2.61a1.13,1.13,0,0,1,.46,1,1.17,1.17,0,0,1-.68.89l-4,2a.66.66,0,0,0-.25.89,8.57,8.57,0,0,1,.43,1.12,1.39,1.39,0,0,0,1,.95l5.35.92a1.33,1.33,0,0,1,1,.63,1.36,1.36,0,0,1,.13,1.15l-.85,2.72a1.92,1.92,0,0,1-1.85,1.3L383,359.5a2.34,2.34,0,0,0-1.5.65,12.9,12.9,0,0,1-1.39,1.24.59.59,0,0,0-.24.41.5.5,0,0,0,.15.39l2.24,2.38a1.12,1.12,0,0,1-.42,1.9l-4.93,2a2.74,2.74,0,0,1-2.32-.24L371.3,366a2.73,2.73,0,0,0-1.67-.33c-1.05.18-2.14.32-3.23.4a1.73,1.73,0,0,0-1.24.81l-1.23,2.39A2.17,2.17,0,0,1,362.09,370.37Zm-11.71-7.62a3.73,3.73,0,0,1,1.44.27c.79.34,1.64.65,2.52.93a1.77,1.77,0,0,1,1.22,1.85l-.28,2.34a.64.64,0,0,0,.57.72l6.16.64a1.31,1.31,0,0,0,1.16-.63l1.22-2.38a2.59,2.59,0,0,1,1.95-1.28c1.06-.08,2.12-.21,3.14-.39a3.59,3.59,0,0,1,2.3.47l3.31,2.2a2,2,0,0,0,1.53.15l4.93-2a.37.37,0,0,0,.24-.21.39.39,0,0,0-.13-.3l-2.23-2.37a1.37,1.37,0,0,1-.39-1.05,1.43,1.43,0,0,1,.57-1,13.39,13.39,0,0,0,1.3-1.16,3.34,3.34,0,0,1,2.15-.91l5.63.23a1,1,0,0,0,1-.7l.85-2.72a.49.49,0,0,0-.41-.67l-5.35-.92a2.24,2.24,0,0,1-1.65-1.56,8.17,8.17,0,0,0-.38-1,1.5,1.5,0,0,1,.65-2l3.95-2c.12-.06.2-.14.21-.22s-.05-.17-.16-.26l-3.14-2.61a1.81,1.81,0,0,0-1.48-.29l-4.79,1.5a3.84,3.84,0,0,1-2.34-.15,22.66,22.66,0,0,0-2.52-.93,1.77,1.77,0,0,1-1.22-1.85l.28-2.34a.66.66,0,0,0-.13-.48.65.65,0,0,0-.44-.24l-6.16-.64a1.28,1.28,0,0,0-1.16.62l-1.22,2.39a2.55,2.55,0,0,1-1.95,1.27c-1.07.08-2.12.22-3.14.39a3.51,3.51,0,0,1-2.3-.46l-3.31-2.2a2,2,0,0,0-1.53-.16l-4.93,2a.37.37,0,0,0-.24.21.41.41,0,0,0,.13.3L348,345.5a1.37,1.37,0,0,1,.39,1.05,1.48,1.48,0,0,1-.57,1,12.44,12.44,0,0,0-1.31,1.16,3.19,3.19,0,0,1-2.14.9l-5.63-.22a1.09,1.09,0,0,0-1,.69l-.85,2.72a.5.5,0,0,0,.41.68l5.35.92a2.25,2.25,0,0,1,1.65,1.55,6.92,6.92,0,0,0,.38,1,1.49,1.49,0,0,1-.65,2l-3.95,2c-.12.06-.2.14-.21.21s0,.17.16.26l3.14,2.62a1.81,1.81,0,0,0,1.48.29l4.79-1.5A3.11,3.11,0,0,1,350.38,362.75Zm13.38-1.39c-3.83,0-7.62-1.06-10-3a5.3,5.3,0,0,1-2.2-4.88c.34-2.16,2.27-4.09,5.28-5.3,5.46-2.18,13-1.38,16.8,1.78h0a5.31,5.31,0,0,1,2.2,4.88c-.34,2.16-2.27,4.1-5.28,5.3A18.45,18.45,0,0,1,363.76,361.36Zm0-13.58a17.78,17.78,0,0,0-6.54,1.18c-2.73,1.09-4.46,2.78-4.75,4.64a4.41,4.41,0,0,0,1.9,4.08c3.59,3,10.74,3.72,15.93,1.64,2.72-1.09,4.45-2.78,4.75-4.63a4.43,4.43,0,0,0-1.9-4.09C370.91,348.77,367.35,347.78,363.73,347.78Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Title--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,116.22,151.68,48.3c1.36-.79,2.46-.15,2.46,1.42V86.25a5.46,5.46,0,0,1-2.46,4.27L34,158.45c-1.36.78-2.46.14-2.46-1.43V120.49A5.46,5.46,0,0,1,34,116.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.45,123.31,164.13,55.39c1.36-.79,2.47-.15,2.47,1.42V93.34a5.47,5.47,0,0,1-2.47,4.27L46.45,165.54c-1.36.79-2.47.15-2.47-1.42V127.58A5.47,5.47,0,0,1,46.45,123.31Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.71,125.16l-6.28-3.65A5.06,5.06,0,0,0,37.7,124v36.53a1.74,1.74,0,0,0,.7,1.58c.46.28,5.84,3.35,6.26,3.62a1.76,1.76,0,0,1-.67-1.57V127.58A5,5,0,0,1,44.71,125.16Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.71,125.16l-6.28-3.65A5.06,5.06,0,0,0,37.7,124v36.53a1.74,1.74,0,0,0,.7,1.58c.46.28,5.84,3.35,6.26,3.62a1.76,1.76,0,0,1-.67-1.57V127.58A5,5,0,0,1,44.71,125.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,55.16c-.88-.53-5.77-3.34-6.17-3.57a1.71,1.71,0,0,0-1.76.16L40.17,119.68a5,5,0,0,0-1.74,1.83l6.28,3.65a5,5,0,0,1,1.74-1.85L164.14,55.39A1.84,1.84,0,0,1,165.78,55.16Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,55.16c-.88-.53-5.77-3.34-6.17-3.57a1.71,1.71,0,0,0-1.76.16L40.17,119.68a5,5,0,0,0-1.74,1.83l6.28,3.65a5,5,0,0,1,1.74-1.85L164.14,55.39A1.84,1.84,0,0,1,165.78,55.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.17,134l4-13,.28-.68a1.49,1.49,0,0,1,.62-.71l1.43-.83a.32.32,0,0,1,.4,0,.7.7,0,0,1,.16.52v20.85a1.66,1.66,0,0,1-.16.71,1.14,1.14,0,0,1-.4.49l-1.7,1a.3.3,0,0,1-.4,0,.7.7,0,0,1-.17-.51V129.24l-2.72,8.84a4.9,4.9,0,0,1-.3.7,1.22,1.22,0,0,1-.48.56l-1.09.62a.38.38,0,0,1-.48,0,1.13,1.13,0,0,1-.29-.37l-2.73-5.68v12.62a1.72,1.72,0,0,1-.17.71,1.06,1.06,0,0,1-.4.49l-1.69,1a.3.3,0,0,1-.4,0,.71.71,0,0,1-.17-.52V127.32a1.68,1.68,0,0,1,.17-.71,1,1,0,0,1,.4-.49l1.42-.82c.28-.16.49-.16.62,0s.23.27.28.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,109.88a.31.31,0,0,1,.4,0,.71.71,0,0,1,.17.52,1.75,1.75,0,0,1,0,.32l-5,16.33v7.1a1.72,1.72,0,0,1-.17.71,1,1,0,0,1-.4.48l-1.68,1a.3.3,0,0,1-.39,0,.68.68,0,0,1-.17-.52v-7.1l-5-10.6a.62.62,0,0,1,0-.26,1.54,1.54,0,0,1,.17-.71,1.06,1.06,0,0,1,.39-.49l1.58-.91c.28-.16.48-.17.62,0a1,1,0,0,1,.26.34l3.39,7.18,3.4-11.1a4.05,4.05,0,0,1,.25-.63,1.56,1.56,0,0,1,.63-.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,100a.3.3,0,0,1,.4,0,.7.7,0,0,1,.17.51v2.3a1.72,1.72,0,0,1-.17.71,1.06,1.06,0,0,1-.4.49l-3.77,2.17v17.69a1.51,1.51,0,0,1-.17.71,1.06,1.06,0,0,1-.39.49l-1.7,1a.3.3,0,0,1-.4,0,.68.68,0,0,1-.17-.51V107.8L94.81,110a.3.3,0,0,1-.4,0,.71.71,0,0,1-.17-.52v-2.29a1.68,1.68,0,0,1,.17-.71,1,1,0,0,1,.4-.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,111a.3.3,0,0,1,.4,0,.71.71,0,0,1,.17.52v2.29a1.72,1.72,0,0,1-.17.71,1.06,1.06,0,0,1-.4.49l-9.2,5.31a.3.3,0,0,1-.4,0,.7.7,0,0,1-.17-.51V99a1.72,1.72,0,0,1,.17-.71,1,1,0,0,1,.4-.49l9-5.21a.31.31,0,0,1,.4,0,.71.71,0,0,1,.17.52V95.4a1.65,1.65,0,0,1-.17.71,1,1,0,0,1-.4.49l-6.77,3.91v5.13l6.31-3.64a.3.3,0,0,1,.4,0,.7.7,0,0,1,.17.51v2.3a1.72,1.72,0,0,1-.17.71,1,1,0,0,1-.4.48l-6.31,3.65V115Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.73,86.36c.22-.13.39-.14.5,0a1.57,1.57,0,0,1,.3.65l5.13,17.44a.68.68,0,0,1,0,.21,1.63,1.63,0,0,1-.16.71,1.14,1.14,0,0,1-.4.49l-1.51.87c-.28.16-.48.19-.59.07a1,1,0,0,1-.23-.4l-.9-3.06-6.63,3.82-.9,4.1a3.34,3.34,0,0,1-.23.67,1.36,1.36,0,0,1-.58.61l-1.51.87a.31.31,0,0,1-.4,0,.67.67,0,0,1-.17-.52,1.66,1.66,0,0,1,0-.24l5.14-23.36a4.7,4.7,0,0,1,.29-1,1.24,1.24,0,0,1,.5-.56Zm1.15,13.5L127.58,92l-2.31,10.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,89.07l4-12.95c.05-.14.15-.37.28-.69a1.48,1.48,0,0,1,.62-.71l1.42-.82a.3.3,0,0,1,.4,0,.7.7,0,0,1,.17.51V95.3a1.72,1.72,0,0,1-.17.71,1,1,0,0,1-.4.49l-1.69,1a.3.3,0,0,1-.4,0,.71.71,0,0,1-.17-.52V84.31l-2.73,8.84a5.25,5.25,0,0,1-.29.7,1.25,1.25,0,0,1-.48.55l-1.09.63c-.2.11-.36.12-.48,0a1.29,1.29,0,0,1-.3-.37L140,89V101.6a1.72,1.72,0,0,1-.17.72,1.09,1.09,0,0,1-.4.48l-1.7,1a.32.32,0,0,1-.4,0,.7.7,0,0,1-.16-.52V82.39a1.63,1.63,0,0,1,.16-.71,1.14,1.14,0,0,1,.4-.49l1.43-.83c.28-.16.48-.16.62,0l.28.36Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Team--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--team-box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.53,167.89h0c.13,0,.37,0,.51.49l0,.14h0a3.2,3.2,0,0,1,0,.42v60.6a5.58,5.58,0,0,1-2.44,4.23L163.78,293.12a2.65,2.65,0,0,1-.5.22h0a1.17,1.17,0,0,1-.3.05c-.49,0-.57-.66-.57-1.05v-60.6a5.1,5.1,0,0,1,.74-2.41,4.89,4.89,0,0,1,1.7-1.81l102.88-59.35a1.76,1.76,0,0,1,.8-.27m0-1.07a2.76,2.76,0,0,0-1.33.4L164.31,226.57a5.83,5.83,0,0,0-2.09,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.35.66,2.13,1.64,2.13a2,2,0,0,0,.61-.1l-.33.12a4.71,4.71,0,0,0,1.05-.43L267.2,234.7a6.62,6.62,0,0,0,3-5.16v-60.6a2.23,2.23,0,0,0-.09-.85,1.57,1.57,0,0,0-1.55-1.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Carrot--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.52,177.83a6.57,6.57,0,0,0-3-5.16l-2.43-1.4a6.57,6.57,0,0,0-5.95,0L171.28,230.61a6.6,6.6,0,0,0-3,5.16v60.6a6.6,6.6,0,0,0,3,5.17l2.43,1.4a6.59,6.59,0,0,0,6,0l102.87-59.35a6.57,6.57,0,0,0,3-5.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.14,171.63a5.08,5.08,0,0,1,2.44.57l2.42,1.4a5.48,5.48,0,0,1,2.44,4.23v60.6a5.46,5.46,0,0,1-2.44,4.23L179.13,302a5.08,5.08,0,0,1-2.44.57,5,5,0,0,1-2.44-.57l-2.43-1.4a5.49,5.49,0,0,1-2.44-4.23v-60.6a5.49,5.49,0,0,1,2.44-4.22L274.69,172.2a5.1,5.1,0,0,1,2.45-.57m0-1.07a6,6,0,0,0-3,.71L171.28,230.61a6.6,6.6,0,0,0-3,5.16v60.6a6.6,6.6,0,0,0,3,5.17l2.43,1.4a6.61,6.61,0,0,0,6,0l102.87-59.35a6.57,6.57,0,0,0,3-5.16v-60.6a6.57,6.57,0,0,0-3-5.16l-2.43-1.4a6,6,0,0,0-3-.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,296.38a6.6,6.6,0,0,0,3,5.16l2.43,1.4a6.71,6.71,0,0,0,5.45.24c-1.4.53-2.47-.26-2.47-2v-60.6a6.08,6.08,0,0,1,.87-2.94l-8.38-4.84a6.06,6.06,0,0,0-.88,2.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,177c-.34-1.26-1.5-1.66-2.87-.87L179.67,235.46a5.93,5.93,0,0,0-2.1,2.22l-8.38-4.84a6,6,0,0,1,2.09-2.22l102.87-59.35a6.65,6.65,0,0,1,6,0l2.44,1.41A6.55,6.55,0,0,1,285.42,177Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.84,231.62C215,225.18,224,230.4,224,243.27s-9,28.51-20.18,34.94-20.18,1.22-20.18-11.64S192.7,238.05,203.84,231.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.76,246.88a2.47,2.47,0,0,0-3.39-.91l-8,4.64V239.22a2.49,2.49,0,0,0-5,0v14.26l-10.53,6.08a2.49,2.49,0,0,0,1.24,4.64,2.44,2.44,0,0,0,1.24-.34l8.05-4.64v11.39a2.49,2.49,0,0,0,5,0V256.35l10.52-6.08A2.47,2.47,0,0,0,217.76,246.88Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--team-box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.53,62.89h0c.13,0,.37,0,.51.49l0,.13h0a3.4,3.4,0,0,1,0,.43v60.6a5.59,5.59,0,0,1-2.44,4.23L163.78,188.11a2.65,2.65,0,0,1-.5.22h0a.86.86,0,0,1-.3.05c-.49,0-.57-.65-.57-1v-60.6a5.07,5.07,0,0,1,.74-2.41,5,5,0,0,1,1.7-1.82L267.73,63.15a1.73,1.73,0,0,1,.8-.26m0-1.08a2.67,2.67,0,0,0-1.33.41L164.31,121.57a5.83,5.83,0,0,0-2.09,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.34.66,2.12,1.64,2.12a2.31,2.31,0,0,0,.61-.09l-.33.11a4.7,4.7,0,0,0,1.05-.42L267.2,129.7a6.62,6.62,0,0,0,3-5.16V63.94a2.23,2.23,0,0,0-.09-.85,1.58,1.58,0,0,0-1.55-1.28Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.53,62.89h0c.13,0,.37,0,.51.49l0,.13h0a3.4,3.4,0,0,1,0,.43v60.6a5.59,5.59,0,0,1-2.44,4.23L163.78,188.11a2.65,2.65,0,0,1-.5.22h0a.86.86,0,0,1-.3.05c-.49,0-.57-.65-.57-1v-60.6a5.07,5.07,0,0,1,.74-2.41,5,5,0,0,1,1.7-1.82L267.73,63.15a1.73,1.73,0,0,1,.8-.26m0-1.08a2.67,2.67,0,0,0-1.33.41L164.31,121.57a5.83,5.83,0,0,0-2.09,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.34.66,2.12,1.64,2.12a2.31,2.31,0,0,0,.61-.09l-.33.11a4.7,4.7,0,0,0,1.05-.42L267.2,129.7a6.62,6.62,0,0,0,3-5.16V63.94a2.23,2.23,0,0,0-.09-.85,1.58,1.58,0,0,0-1.55-1.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--carrot--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.7,198.09a5.46,5.46,0,0,1-2.71-.64l-2.43-1.4a6.12,6.12,0,0,1-2.71-4.69v-60.6a6.12,6.12,0,0,1,2.71-4.7L274.44,66.72a6.06,6.06,0,0,1,5.42,0l2.42,1.4a6.1,6.1,0,0,1,2.71,4.7v60.6a6.09,6.09,0,0,1-2.71,4.69L179.41,197.45A5.43,5.43,0,0,1,176.7,198.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.15,66.62a5.08,5.08,0,0,1,2.44.57l2.42,1.4a5.46,5.46,0,0,1,2.44,4.23v60.6a5.47,5.47,0,0,1-2.45,4.22L179.14,197a5,5,0,0,1-2.44.57,5.08,5.08,0,0,1-2.44-.57l-2.43-1.4a5.5,5.5,0,0,1-2.44-4.23v-60.6a5.49,5.49,0,0,1,2.44-4.23L274.71,67.19a5,5,0,0,1,2.44-.57m0-1.08a6.13,6.13,0,0,0-3,.71L171.3,125.6a6.57,6.57,0,0,0-3,5.16v60.6a6.57,6.57,0,0,0,3,5.16l2.42,1.4a6.61,6.61,0,0,0,6,0l102.87-59.34a6.57,6.57,0,0,0,3-5.16V72.82a6.59,6.59,0,0,0-3-5.17l-2.42-1.4a6.16,6.16,0,0,0-3-.71Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.32,191.36a6.57,6.57,0,0,0,3,5.16l2.42,1.4a6.67,6.67,0,0,0,5.45.24c-1.4.53-2.47-.26-2.47-2V135.6a6.11,6.11,0,0,1,.87-2.94l-8.38-4.84a6.11,6.11,0,0,0-.87,2.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,72c-.34-1.27-1.5-1.67-2.87-.88L179.68,130.44a5.88,5.88,0,0,0-2.1,2.23l-8.38-4.84a6,6,0,0,1,2.1-2.23L274.16,66.26a6.61,6.61,0,0,1,6,0l2.43,1.4A6.57,6.57,0,0,1,285.43,72Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,72c-.34-1.27-1.5-1.67-2.87-.88L179.68,130.44a5.88,5.88,0,0,0-2.1,2.23l-8.39-4.85a6.11,6.11,0,0,1,2.11-2.22L274.16,66.26a6.61,6.61,0,0,1,6,0l2.43,1.4A6.57,6.57,0,0,1,285.43,72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.51,136.4c0,7.1-2.47,14.95-6.48,21.93-.63,1.11-1.31,2.2-2,3.26s-1.45,2.08-2.22,3.07-1.39,1.73-2.12,2.55c-.34.38-.69.77-1,1.14a38.83,38.83,0,0,1-8.53,6.87,26,26,0,0,1-4.68,2.14c-.52.17-1,.32-1.54.43a13.45,13.45,0,0,1-8-.24c-5-1.85-8.19-7.21-8.2-15.27,0-14.29,10-31.67,22.42-38.82S227.51,122.11,227.51,136.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.54,157.44c-.18.31-.33.6-.5.89-.35.61-.71,1.21-1.09,1.8s-.62,1-.94,1.46c-.71,1.06-1.45,2.08-2.22,3.07l-.21.26-1.2-6.66A15.83,15.83,0,0,1,221.54,157.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220,160.13c-.3.48-.62,1-.94,1.46-.71,1.06-1.45,2.08-2.22,3.07l-.21.26c-.62.79-1.25,1.56-1.91,2.29l-1,1.14a38.53,38.53,0,0,1-8.54,6.88,26.19,26.19,0,0,1-4.67,2.13c-.52.17-1,.32-1.55.44a14.36,14.36,0,0,1-5.85.3,10.54,10.54,0,0,1-4.65-1.87c.25-1.86.75-3.31,1.56-4,3-2.33,4.64-3.8,6.11-4.87a22.23,22.23,0,0,1,11-7c2.68-.7,5.36-1.48,8.38-2.15A4.49,4.49,0,0,1,220,160.13Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.51,135.71c-2.93,4.84-1.78,10.31-.46,14.74,1.53,5,2.15,6.92,3.85,7.55-1.33-16.73,4.5,1.72,15.8-14.62,2-2.95,2.41-10.65-.33-13.28C211.5,126.38,202.25,126.52,196.51,135.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83,155.23c1.69.8,3.11-1.51,3.11-1.51l.84,11.1s0,1.44,2.93,2.45c1.93.66,5.93.27,8.2,2.24,1-2.12,1.73-5.77-.41-8.13l-.17-3.38a16.27,16.27,0,0,0,3.3-1.2c1.56-.9,2.59-2.44,3.13-5.14.86-4.35.45-10.43-1.16-18-2.36-1.46-9.92.14-14.65,4.86.38,4.62-.7,7-.64,8.68a6.1,6.1,0,0,1-.84,1.55c-.73.93-1.4-.84-2.06-1.44s-2.75-1.1-3.69,1.64S194.36,154.55,195.83,155.23Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,158c-2,.46-5.8.3-7.29-.88a11.24,11.24,0,0,1-2.47-2.93,7,7,0,0,0,2.19,4.05c3.05,2.4,7.67,1.43,7.67,1.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.3,141.23l-2,1.93a1.7,1.7,0,0,1,.32-2A1,1,0,0,1,206.3,141.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,138.81l-2.36-.14a1.45,1.45,0,0,1,1.4-1.3A1.15,1.15,0,0,1,215.15,138.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,144.65a.81.81,0,0,0,1,.82,1.39,1.39,0,0,0,.9-1.38.81.81,0,0,0-1-.82A1.41,1.41,0,0,0,205.47,144.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,142.08a.8.8,0,0,0,1,.81,1.36,1.36,0,0,0,.9-1.38.81.81,0,0,0-1-.82A1.4,1.4,0,0,0,213,142.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,142.26l1.41,6.49,3.18-2.27C212.61,144.59,210.63,142.66,209.25,142.26Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,151l3.48.18a1.67,1.67,0,0,1-1.75,1.59A1.76,1.76,0,0,1,208.12,151Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.85,152.75a1.73,1.73,0,0,0,.86-.19,2.09,2.09,0,0,0-1.89-1.2,2,2,0,0,0-.64.11A1.85,1.85,0,0,0,209.85,152.75Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.91,169.51c-1.26-.51-4.57-1.21-4.84-.2-.18.72-.72,3.28-1.65,3.47a8.48,8.48,0,0,1-6.84-2.56,5.17,5.17,0,0,1-1.53-2.82s1.1-2.85,1.78-4.2.86-2.14,1.63-2.41l.2,2.33a5.81,5.81,0,0,0,2.28,2.13C204.18,166.39,208.65,167.08,210.91,169.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,169.51c.68-1,1.81-4.44,2.4-4.47,1.23-.07,2.06.71,2.06,0s-.91-2-2-3.86c-.84-1.4-2.19-2.38-3-2.31l.19,3.23a7.75,7.75,0,0,1,.64,2.65A11.28,11.28,0,0,1,210.91,169.51Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193,178.1a10.52,10.52,0,0,1-6.16-3.19,30.2,30.2,0,0,1,3.07-2.65A14.41,14.41,0,0,1,193,178.1Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.11,121.64h0c6.88,0,11.16,5.66,11.16,14.76,0,6.65-2.24,14.22-6.32,21.32-.61,1.07-1.27,2.14-2,3.18s-1.43,2-2.18,3-1.39,1.73-2.07,2.49l-1,1.11a37.59,37.59,0,0,1-8.25,6.65,24.56,24.56,0,0,1-4.44,2c-.5.16-1,.3-1.46.41a14.62,14.62,0,0,1-3.5.45,10.78,10.78,0,0,1-3.77-.65c-4.69-1.74-7.39-6.88-7.39-14.11,0-13.88,9.78-30.81,21.8-37.74a19.22,19.22,0,0,1,9.39-2.9m0-1.24a20.25,20.25,0,0,0-10,3.06c-12.39,7.15-22.42,24.53-22.42,38.82,0,8.06,3.19,13.42,8.2,15.27a12,12,0,0,0,4.2.73,15.67,15.67,0,0,0,3.8-.49c.5-.11,1-.26,1.54-.43a26,26,0,0,0,4.68-2.14,38.83,38.83,0,0,0,8.53-6.87c.35-.37.7-.76,1-1.14.73-.82,1.43-1.67,2.12-2.55s1.51-2,2.22-3.07,1.39-2.15,2-3.26c4-7,6.48-14.83,6.48-21.93,0-10.14-5-16-12.4-16Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.77,115,275,99.85c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-26.27,15.16c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,248.77,115Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,125.52a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l36.56-21.11a.5.5,0,0,1,.5.87l-36.56,21.11A.57.57,0,0,1,243.63,125.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,130.21a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l36.56-21.11a.51.51,0,0,1,.68.19.5.5,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,243.63,130.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,134.9a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l36.56-21.11a.51.51,0,0,1,.68.19.5.5,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,243.63,134.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,139.6a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l36.56-21.1a.5.5,0,0,1,.68.18.5.5,0,0,1-.18.68l-36.56,21.11A.59.59,0,0,1,243.63,139.6Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--team-box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.72,137.75h0c.13,0,.38,0,.51.48l0,.14h0a3.4,3.4,0,0,1,0,.43v60.6a5.58,5.58,0,0,1-2.44,4.22L34,263a2.53,2.53,0,0,1-.49.22h0a.86.86,0,0,1-.3.05c-.49,0-.56-.65-.56-1v-60.6a5,5,0,0,1,.74-2.41,4.77,4.77,0,0,1,1.7-1.82L137.92,138a1.76,1.76,0,0,1,.8-.26m0-1.08a2.67,2.67,0,0,0-1.33.41L34.51,196.43a5.93,5.93,0,0,0-2.1,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.34.67,2.12,1.64,2.12a2.25,2.25,0,0,0,.61-.09l-.33.11a5,5,0,0,0,1.06-.42l102.88-59.35a6.6,6.6,0,0,0,3-5.16V138.8a2,2,0,0,0-.1-.85,1.58,1.58,0,0,0-1.55-1.28Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.72,137.75h0c.13,0,.38,0,.51.48l0,.14h0a3.4,3.4,0,0,1,0,.43v60.6a5.58,5.58,0,0,1-2.44,4.22L34,263a2.53,2.53,0,0,1-.49.22h0a.86.86,0,0,1-.3.05c-.49,0-.56-.65-.56-1v-60.6a5,5,0,0,1,.74-2.41,4.77,4.77,0,0,1,1.7-1.82L137.92,138a1.76,1.76,0,0,1,.8-.26m0-1.08a2.67,2.67,0,0,0-1.33.41L34.51,196.43a5.93,5.93,0,0,0-2.1,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.34.67,2.12,1.64,2.12a2.25,2.25,0,0,0,.61-.09l-.33.11a5,5,0,0,0,1.06-.42l102.88-59.35a6.6,6.6,0,0,0,3-5.16V138.8a2,2,0,0,0-.1-.85,1.58,1.58,0,0,0-1.55-1.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--carrot--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.89,273a5.57,5.57,0,0,1-2.71-.64l-2.43-1.4a6.1,6.1,0,0,1-2.71-4.7v-60.6a6.09,6.09,0,0,1,2.71-4.69l102.88-59.35a5.51,5.51,0,0,1,2.71-.64,5.57,5.57,0,0,1,2.71.64l2.42,1.4a6.1,6.1,0,0,1,2.71,4.7v60.6a6.06,6.06,0,0,1-2.71,4.69L49.6,272.32A5.54,5.54,0,0,1,46.89,273Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,141.48a5.08,5.08,0,0,1,2.44.57l2.42,1.4a5.46,5.46,0,0,1,2.44,4.23v60.6a5.48,5.48,0,0,1-2.44,4.23L49.33,271.85a5.51,5.51,0,0,1-4.88,0L42,270.45a5.49,5.49,0,0,1-2.44-4.23v-60.6A5.5,5.5,0,0,1,42,201.39L144.9,142.05a5,5,0,0,1,2.44-.57m0-1.08a6,6,0,0,0-3,.72L41.48,200.46a6.59,6.59,0,0,0-3,5.16v60.6a6.59,6.59,0,0,0,3,5.16l2.43,1.4a6.53,6.53,0,0,0,6,0l102.87-59.34a6.57,6.57,0,0,0,3-5.16v-60.6a6.57,6.57,0,0,0-3-5.16l-2.42-1.4a6.06,6.06,0,0,0-3-.72Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.51,266.22a6.59,6.59,0,0,0,3,5.16l2.43,1.4a6.63,6.63,0,0,0,5.45.24c-1.4.53-2.47-.26-2.47-2v-60.6a6,6,0,0,1,.87-2.93l-8.38-4.84a6,6,0,0,0-.87,2.93Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,146.83c-.34-1.26-1.5-1.67-2.87-.87L49.87,205.31a5.85,5.85,0,0,0-2.1,2.22l-8.38-4.84a6,6,0,0,1,2.1-2.22l102.86-59.35a6.59,6.59,0,0,1,6,0l2.44,1.4A6.59,6.59,0,0,1,155.62,146.83Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,146.83c-.34-1.26-1.5-1.67-2.87-.87L49.87,205.31a5.85,5.85,0,0,0-2.1,2.22l-8.39-4.84a6,6,0,0,1,2.11-2.22l102.86-59.35a6.59,6.59,0,0,1,6,0l2.44,1.4A6.59,6.59,0,0,1,155.62,146.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.73,211.33c0,7.1-2.47,14.95-6.48,21.93q-.94,1.68-2,3.27c-.72,1.05-1.46,2.07-2.23,3.07s-1.39,1.73-2.11,2.54c-.34.39-.7.77-1.05,1.14a38.37,38.37,0,0,1-8.53,6.87,25.21,25.21,0,0,1-4.67,2.14c-.52.17-1,.32-1.55.44a13.5,13.5,0,0,1-8-.25c-5-1.85-8.2-7.21-8.21-15.26,0-14.3,10-31.68,22.42-38.82S97.73,197,97.73,211.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.25,233.26q-.94,1.68-2,3.27c-.72,1.05-1.46,2.07-2.23,3.07l-2-5.74h0C87.72,233,89.48,232.62,91.25,233.26Z",
    style: {
      fill: "#965d4a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.11,235.62c-.71,1.06-1.46,2.08-2.23,3.07s-1.39,1.73-2.11,2.55c-.34.38-.7.77-1,1.14a38.37,38.37,0,0,1-8.53,6.87,25.88,25.88,0,0,1-4.67,2.14c-.52.17-1,.31-1.55.43a25.61,25.61,0,0,0-2.41-10.57s1.86-1,5.41-2.92l.11-.08c2.83-1.94,4.74-1.6,9.94-3.82.09-.05-.64-.42-.55-.45l3.41-1h0A38.55,38.55,0,0,1,89.11,235.62Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.74,207.37c-3.24-4-10.44-6-18.63,1.27s-9.8,23.19-1.28,26.87c6.41,2.78,16.5,2.16,19.75-4.42-4,1-1.39-7.47.66-11.76C91.57,214.43,90.62,209.69,88.74,207.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73,226.27a8.77,8.77,0,0,1-1.44,3.35c-.92,1.09-2.19,1.69-4.28,2.4l.06,1.44,0,.92,0,1,0,1.65s2.53,3,2.72,5.16c-.34.39-.7.77-1.05,1.14a24.35,24.35,0,0,1-11.75-3.81v-.24L72,236.84,71.72,231l0-1.65a1.46,1.46,0,0,1-.27.62,2.34,2.34,0,0,1-.87.72,2.55,2.55,0,0,1-2.13.12.71.71,0,0,1-.15-.08.85.85,0,0,1-.23-.12.87.87,0,0,1-.18-.11.71.71,0,0,1-.14-.1h0a.61.61,0,0,1-.15-.12,4.23,4.23,0,0,1-1.26-4.89c.52-1.23,1.93-2.33,3-1.91s1.2,1.08,1.66,1.83,2.63-1.54,1.13-5.44c1.79-1.4,3.22-4.34,2.75-5.91.77-2.82,5.44-3.52,6.36-2.45.77-1.78,2.25-2.82,3.74-2.36s2.83,1.37,3.29,7.57c.08,1,.11,2.15.11,2.56A34.38,34.38,0,0,1,87.73,226.27Z",
    style: {
      fill: "#965d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,225.92l3.13.09a2.05,2.05,0,0,1-2,1.82C78.83,227.76,78.45,227,78.6,225.92Z",
    style: {
      fill: "#783f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.57,227.64a1.36,1.36,0,0,0-1.83-1.12l-.16.07a1.22,1.22,0,0,0,1.11,1.24A1.77,1.77,0,0,0,80.57,227.64Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.52 217.67 82.24 223.79 85.17 221.81 81.52 217.67",
    style: {
      fill: "#783f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,232a21.54,21.54,0,0,1-6.85.14c-.71-.11-1.76-1.22-2.65-2.55,0,0,.8,2.93,2.37,3.51,2.4.9,7.18.33,7.18.33Z",
    style: {
      fill: "#783f2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6,214.94l-2.24.14a1.83,1.83,0,0,1,1.46-1.31C86.44,213.73,86.79,214.26,86.6,214.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.19,216.93l-2.44,1.62a1.73,1.73,0,0,1,.83-1.83C78.26,216.27,79,216.37,79.19,216.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.24,217.46c.13.43-.22.7-.69,1s-.91.54-1,.11a1.3,1.3,0,0,1,.63-1.33C85.63,216.93,86.12,217,86.24,217.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,217.55a4.21,4.21,0,0,1,.68-.45,2.46,2.46,0,0,1,.7-.25,2,2,0,0,1,.68,0s0,0,0,.06a6.23,6.23,0,0,0-.62.14,4.05,4.05,0,0,0-.78.33,5.61,5.61,0,0,0-.9.6l-.3.25s0,0,0-.06A2.94,2.94,0,0,1,84.7,217.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,220.13c-.15.53.19.54.66.5s.89-.13,1-.66-.11-.93-.58-.89A1.51,1.51,0,0,0,77.35,220.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,219.06a2,2,0,0,0-.68.06,2.17,2.17,0,0,0-.69.26,3.9,3.9,0,0,0-.7.49s0,.07,0,.06c.19-.1.35-.2.63-.33a4,4,0,0,1,.77-.24,2.9,2.9,0,0,1,.89-.06l.29,0s0-.07,0-.09A1,1,0,0,0,78.93,219.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.65,252.29c-.52.17-1,.32-1.55.44a13.5,13.5,0,0,1-8-.25,8.49,8.49,0,0,1-2.49-2c2.75-6.49,4.2-7.73,7.94-9.27h0C69.1,243.11,70.23,249.43,70.65,252.29Z",
    style: {
      fill: "#965d4a"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M85.33,196.57h0c6.89,0,11.16,5.66,11.16,14.76,0,6.65-2.24,14.22-6.31,21.32-.61,1.07-1.27,2.15-2,3.18s-1.43,2-2.18,3-1.38,1.72-2.06,2.48c-.33.38-.68.75-1,1.11a37.31,37.31,0,0,1-8.25,6.65,24.25,24.25,0,0,1-4.44,2c-.5.17-1,.3-1.45.41a14.63,14.63,0,0,1-3.51.45,10.72,10.72,0,0,1-3.76-.65c-4.7-1.74-7.39-6.88-7.4-14.1,0-13.88,9.78-30.82,21.8-37.75a19.25,19.25,0,0,1,9.39-2.9m0-1.24a20.33,20.33,0,0,0-10,3.07c-12.38,7.14-22.42,24.52-22.42,38.82,0,8.05,3.2,13.41,8.21,15.26a11.9,11.9,0,0,0,4.19.73,16.15,16.15,0,0,0,3.8-.48c.51-.12,1-.27,1.55-.44a25.21,25.21,0,0,0,4.67-2.14,38.37,38.37,0,0,0,8.53-6.87c.35-.37.71-.75,1.05-1.14.72-.81,1.43-1.67,2.11-2.54s1.51-2,2.23-3.07,1.38-2.15,2-3.27c4-7,6.48-14.83,6.48-21.93,0-10.14-5-16-12.4-16Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,194.14,138.14,179c.59-.34,1.08-.1,1.08.55a2.35,2.35,0,0,1-1.08,1.8l-26.27,15.16c-.6.35-1.08.1-1.09-.54A2.32,2.32,0,0,1,111.87,194.14Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,204.64a.5.5,0,0,1-.25-.93L143,182.6a.5.5,0,1,1,.5.87L107,204.58A.51.51,0,0,1,106.72,204.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,209.33a.48.48,0,0,1-.43-.25.5.5,0,0,1,.18-.68L143,187.29a.52.52,0,0,1,.69.19.51.51,0,0,1-.19.68L107,209.27A.51.51,0,0,1,106.72,209.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,214a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L143,192a.5.5,0,1,1,.5.86L107,214A.52.52,0,0,1,106.72,214Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,218.72a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L143,196.68a.5.5,0,1,1,.5.86L107,218.65A.52.52,0,0,1,106.72,218.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--team-box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.72,242.75h0c.13,0,.38,0,.51.49l0,.14h0a3.2,3.2,0,0,1,0,.42v60.6a5.58,5.58,0,0,1-2.44,4.23L34,368a3.33,3.33,0,0,1-.49.22h0a1.17,1.17,0,0,1-.3.05c-.49,0-.56-.66-.56-1.05v-60.6a5,5,0,0,1,.74-2.41,4.74,4.74,0,0,1,1.7-1.81L137.92,243a1.79,1.79,0,0,1,.8-.27m0-1.07a2.76,2.76,0,0,0-1.33.4L34.51,301.43a5.93,5.93,0,0,0-2.1,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.35.67,2.13,1.64,2.13a1.94,1.94,0,0,0,.61-.1l-.33.12a5,5,0,0,0,1.06-.43l102.88-59.35a6.6,6.6,0,0,0,3-5.16V243.8a2,2,0,0,0-.1-.85,1.57,1.57,0,0,0-1.55-1.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.72,242.75h0c.13,0,.38,0,.51.49l0,.14h0a3.2,3.2,0,0,1,0,.42v60.6a5.58,5.58,0,0,1-2.44,4.23L34,368a3.33,3.33,0,0,1-.49.22h0a1.17,1.17,0,0,1-.3.05c-.49,0-.56-.66-.56-1.05v-60.6a5,5,0,0,1,.74-2.41,4.74,4.74,0,0,1,1.7-1.81L137.92,243a1.79,1.79,0,0,1,.8-.27m0-1.07a2.76,2.76,0,0,0-1.33.4L34.51,301.43a5.93,5.93,0,0,0-2.1,2.22,6.09,6.09,0,0,0-.88,2.94v60.6c0,1.35.67,2.13,1.64,2.13a1.94,1.94,0,0,0,.61-.1l-.33.12a5,5,0,0,0,1.06-.43l102.88-59.35a6.6,6.6,0,0,0,3-5.16V243.8a2,2,0,0,0-.1-.85,1.57,1.57,0,0,0-1.55-1.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--carrot--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.88,378a5.43,5.43,0,0,1-2.71-.64l-2.43-1.4A6.09,6.09,0,0,1,39,371.24v-60.6a6.1,6.1,0,0,1,2.71-4.7L144.61,246.6a5.57,5.57,0,0,1,2.71-.64,5.51,5.51,0,0,1,2.71.64l2.43,1.4a6.09,6.09,0,0,1,2.71,4.69V313.3a6.09,6.09,0,0,1-2.71,4.69L49.59,377.33A5.46,5.46,0,0,1,46.88,378Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,246.5a5,5,0,0,1,2.45.57l2.42,1.4a5.49,5.49,0,0,1,2.44,4.22V313.3a5.49,5.49,0,0,1-2.44,4.22L49.32,376.87a5.08,5.08,0,0,1-2.44.56,5,5,0,0,1-2.44-.56L42,375.47a5.5,5.5,0,0,1-2.44-4.23v-60.6A5.49,5.49,0,0,1,42,306.41l102.87-59.34a5,5,0,0,1,2.44-.57m0-1.08a6.12,6.12,0,0,0-3,.71L41.47,305.48a6.6,6.6,0,0,0-3,5.16v60.6a6.6,6.6,0,0,0,3,5.16l2.43,1.4a6.61,6.61,0,0,0,6,0l102.87-59.34a6.57,6.57,0,0,0,3-5.16V252.69a6.57,6.57,0,0,0-3-5.16l-2.43-1.4a6.13,6.13,0,0,0-3-.71Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.49,371.24a6.6,6.6,0,0,0,3,5.16l2.43,1.4a6.67,6.67,0,0,0,5.45.24c-1.4.53-2.47-.26-2.47-2v-60.6a6.11,6.11,0,0,1,.87-2.94l-8.38-4.84a6.09,6.09,0,0,0-.88,2.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.61,251.85c-.35-1.27-1.5-1.67-2.88-.88L49.86,310.32a5.93,5.93,0,0,0-2.1,2.22l-8.38-4.83a6,6,0,0,1,2.09-2.23l102.87-59.35a6.65,6.65,0,0,1,6,0l2.43,1.41A6.55,6.55,0,0,1,155.61,251.85Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.61,251.85c-.35-1.27-1.5-1.67-2.88-.88L49.86,310.32a5.93,5.93,0,0,0-2.1,2.22l-8.38-4.83a6,6,0,0,1,2.09-2.23l102.87-59.35a6.65,6.65,0,0,1,6,0l2.43,1.41A6.55,6.55,0,0,1,155.61,251.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.44,316.84c0,7.1-2.47,15-6.47,21.93-.63,1.11-1.31,2.2-2,3.26s-1.45,2.08-2.22,3.07-1.39,1.73-2.12,2.55l-1,1.14A38.65,38.65,0,0,1,74,355.66a25.57,25.57,0,0,1-4.67,2.14c-.52.17-1,.32-1.54.43a13.45,13.45,0,0,1-8-.24c-5-1.86-8.2-7.21-8.2-15.27,0-14.29,10-31.67,22.41-38.82S96.44,302.54,96.44,316.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.46,341.15c-.41.7-.83,1.4-1.28,2.08l-.11.18c-.3.47-.62.95-.95,1.41s-.8,1.14-1.22,1.71c0,0-.06.07-.08.11-.7.94-1.42,1.84-2.15,2.71l-1,1.22-.81.88,0,0A35.08,35.08,0,0,1,74,355.65a25.65,25.65,0,0,1-4.67,2.15,15.65,15.65,0,0,1-1.55.43,19.23,19.23,0,0,1-2.13.39,13.14,13.14,0,0,1-3.88-.1,10.35,10.35,0,0,1-2-.54,10.63,10.63,0,0,1-4.4-3.07,14.6,14.6,0,0,1-3.13-6.34,34.15,34.15,0,0,1,3.42-3.95c5.64-5.66,6.77-11.34,6.2-16.76l22.47.84C84.66,333.53,86.35,337.35,87.46,341.15Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.07,343.41c-.31.47-.62.94-.95,1.41s-.81,1.14-1.22,1.71l-2.11-6.61c4.44-1.35,5.24-.78,6.51-.24-.43.85-1.52,2.61-2.12,3.55C86.15,343.29,86.11,343.34,86.07,343.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.12,344.82c-.4.58-.8,1.14-1.22,1.71,0,0-.06.07-.08.11-.7.94-1.42,1.84-2.15,2.71l-1,1.22-.81.88,0,0A35.08,35.08,0,0,1,74,355.65a25.65,25.65,0,0,1-4.67,2.15,15.65,15.65,0,0,1-1.55.43,19.23,19.23,0,0,1-2.13.39,13.14,13.14,0,0,1-3.88-.1c0-.13,0-.27,0-.4-.43-9,2.66-11.28,2.71-11.3s1.27-.61,2-.94c1.45-.66,11.91-2.59,11.91-2.59l3.39-3.37a11.28,11.28,0,0,1,4.77,2.72S85.9,343.66,85.12,344.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.76,318.2c-3.87,1.69-4.4,8.69-3.25,12.17,2.23,6.72,7,6.09,7.33,9.15L76.57,333l5.24-5.09c2.3-2.23,5.8-3.82,6.43-7.56.21-1.28-.16-2.76-1.41-3.15a5.51,5.51,0,0,0,1.2-4.45c-.45-3.29-3.85-4.59-6.64-4.89A15.22,15.22,0,0,0,72.58,310C69.56,311.67,66.48,314.54,65.76,318.2Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.18,342.38l-.8-6.63a2.78,2.78,0,0,1-3.49.37,4.16,4.16,0,0,1-1.42-5.51,2.91,2.91,0,0,1,4.88-.56c1.7-.11,2.22-2.83.8-5,0,0,3.27-3.16,2.4-6.72,3,1,9.75-.24,11.16-3.89,1,1.17,2.52,1.32,3,9.27.43,7.27-.93,10.2-2.76,11.66a10.7,10.7,0,0,1-4.59,2.32l.2,1.84h0c.1.93.31.89,1.09.69l1.16-.29s1.56,2.41-3.92,4.92c-8.2,3.75-11.38,1-11.38,1l1.89-.87A2.55,2.55,0,0,0,70.18,342.38Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.85,331.54l3,.07A2.09,2.09,0,0,1,78,333.35C77.17,333.33,76.65,332.52,76.85,331.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.08,332.21a1.32,1.32,0,0,1,1.8.88,1.63,1.63,0,0,1-.87.26,1.22,1.22,0,0,1-1.16-1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,321l-2.26-.33a1.5,1.5,0,0,1,1.51-1.16A1.08,1.08,0,0,1,85,321Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45,324.65l2.06-1.91a1,1,0,0,0-1.65,0A1.63,1.63,0,0,0,74.45,324.65Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.65 323.09 80.36 329.66 83.53 327.23 79.65 323.09",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,323.4a.8.8,0,0,0,1,.86,1.36,1.36,0,0,0,1-1.27.81.81,0,0,0-1-.86A1.34,1.34,0,0,0,82.5,323.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.23,325.86a.8.8,0,0,0,1,.86,1.36,1.36,0,0,0,1-1.27.81.81,0,0,0-1-.86A1.36,1.36,0,0,0,75.23,325.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,337.68c-3.84.78-7.57.61-8.53-1,0,0,.1,2,1.7,2.48,2.25.67,7-.13,7-.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.68,358.62a13.14,13.14,0,0,1-3.88-.1,11,11,0,0,1-4.75-2.07c2.72-7.34,3.17-7.93,7.44-9.63,0,0,0,0,0,0C68,350.14,66.32,356.51,65.68,358.62Z",
    style: {
      fill: "#ffc4c3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,302.08h0c6.88,0,11.16,5.65,11.16,14.76,0,6.65-2.25,14.22-6.32,21.32-.61,1.07-1.27,2.14-2,3.18s-1.42,2-2.17,3-1.39,1.73-2.07,2.49l-1,1.11a37.64,37.64,0,0,1-8.26,6.65,24,24,0,0,1-4.44,2c-.49.16-1,.3-1.45.41a14.62,14.62,0,0,1-3.5.45,10.78,10.78,0,0,1-3.77-.65c-4.69-1.74-7.39-6.88-7.39-14.11,0-13.88,9.77-30.81,21.79-37.74a19.25,19.25,0,0,1,9.4-2.9m0-1.24a20.31,20.31,0,0,0-10,3.06c-12.38,7.15-22.41,24.53-22.41,38.82,0,8.06,3.19,13.41,8.2,15.27a12,12,0,0,0,4.2.73,15.67,15.67,0,0,0,3.8-.49c.5-.11,1-.26,1.54-.43A25.57,25.57,0,0,0,74,355.66a38.65,38.65,0,0,0,8.54-6.87l1-1.14c.73-.82,1.43-1.67,2.12-2.55s1.51-2,2.22-3.07,1.39-2.15,2-3.26c4-7,6.47-14.83,6.47-21.93,0-10.14-5-16-12.4-16Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,299.94l26.27-15.17c.59-.34,1.08-.1,1.08.55a2.35,2.35,0,0,1-1.08,1.8l-26.27,15.16c-.6.35-1.08.1-1.09-.54A2.32,2.32,0,0,1,111.87,299.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,310.45a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L143,288.4a.52.52,0,0,1,.69.19.51.51,0,0,1-.19.68L107,310.38A.52.52,0,0,1,106.72,310.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,315.14a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L143,293.1a.5.5,0,1,1,.5.86L107,315.07A.52.52,0,0,1,106.72,315.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,319.83a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L143,297.79a.5.5,0,1,1,.5.86L107,319.76A.43.43,0,0,1,106.72,319.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,324.52a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L143,302.48a.5.5,0,1,1,.5.86L107,324.45A.43.43,0,0,1,106.72,324.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Options--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,128.26c0,8.88,3.09,18.69,8.09,27.41.79,1.39,1.64,2.76,2.53,4.08s1.81,2.6,2.78,3.84,1.73,2.16,2.64,3.18c.43.49.87,1,1.31,1.43A48.35,48.35,0,0,0,445,176.79a32.15,32.15,0,0,0,5.84,2.67c.65.21,1.3.4,1.93.55a17,17,0,0,0,10-.31c6.26-2.32,10.25-9,10.25-19.08,0-17.87-12.54-39.6-28-48.53S417,110.39,417,128.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.93,161.47c.38.59.77,1.19,1.19,1.77s1,1.43,1.52,2.14l2.64-8.27c-5.55-1.68-6.55-1-8.13-.29.53,1.06,1.89,3.25,2.64,4.43C429.83,161.33,429.88,161.39,429.93,161.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.12,163.24c.5.72,1,1.42,1.52,2.14l.11.13c.87,1.18,1.77,2.31,2.68,3.39.44.52.88,1,1.31,1.52l1,1.1,0,0a43.81,43.81,0,0,0,7.19,5.23,32.92,32.92,0,0,0,5.84,2.68,18.86,18.86,0,0,0,1.94.54,22.18,22.18,0,0,0,2.67.49,16.59,16.59,0,0,0,4.85-.13c0-.16,0-.33,0-.5.53-11.21-3.33-14.09-3.39-14.12s-1.59-.76-2.51-1.18c-1.81-.83-14.88-3.24-14.88-3.24l-4.24-4.21s-3.89,1.06-6,3.4C429.32,160.51,430.14,161.79,431.12,163.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.32,130c4.83,2.11,5.5,10.85,4.05,15.21-2.78,8.4-8.69,7.61-9.15,11.43-6-6.13-12.73-11.88-18.51-18.06-1.77-2.06-6.85-3.88-4.54-7.25a2.44,2.44,0,0,1-3-3.61c.83,3.37,4.2.69,2.07-1.84-2.75-5.73,5.07-8.28,9.46-8.56C443.76,116.2,453.2,121.75,455.32,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.79,160.19l1-8.29s2.12,2.09,4.37.46a5.2,5.2,0,0,0,1.77-6.88,3.63,3.63,0,0,0-6.1-.7c-2.12-.14-2.78-3.55-1-6.26,0,0-4.09-4-3-8.41-3.74,1.24-12.19-.29-13.95-4.86-1.14,1.31-3.09,3.63-2.64,9.08a16.71,16.71,0,0,1-.77,3.45c-1.21,5.53.85,11.8,3.13,13.64a13.43,13.43,0,0,0,5.75,2.89l-.26,2.31h0c-.12,1.16-.39,1.11-1.36.86l-1.45-.37s-2,3,4.9,6.15c10.24,4.69,14.22,1.3,14.22,1.3s-.59-.26-2.36-1.08A3.18,3.18,0,0,1,449.79,160.19Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.46,146.64l-3.81.09A2.61,2.61,0,0,0,440,148.9,1.71,1.71,0,0,0,441.46,146.64Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.17,147.48a1.66,1.66,0,0,0-2.26,1.09,2,2,0,0,0,1.09.33,1.52,1.52,0,0,0,1.45-1.29A1.43,1.43,0,0,0,441.17,147.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.26,133.52l2.83-.42a1.87,1.87,0,0,0-1.89-1.45A1.37,1.37,0,0,0,431.26,133.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.46,138l-2.59-2.38a1.31,1.31,0,0,1,2.07,0A2,2,0,0,1,444.46,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.96 136.08 437.07 144.29 433.1 141.25 437.96 136.08",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4,136.46a1,1,0,0,1-1.24,1.08,1.69,1.69,0,0,1-1.28-1.59,1,1,0,0,1,1.24-1.08A1.73,1.73,0,0,1,434.4,136.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.47,139.54a1,1,0,0,1-1.23,1.08A1.69,1.69,0,0,1,441,139,1,1,0,0,1,442.2,138,1.69,1.69,0,0,1,443.47,139.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.35,154.31c4.8,1,9.45.76,10.66-1.19,0,0-.13,2.5-2.13,3.1-2.81.83-8.73-.17-8.73-.17Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.42,180.49a16.59,16.59,0,0,0,4.85-.13,13.72,13.72,0,0,0,5.94-2.58c-3.41-9.18-4-9.91-9.3-12-.05,0,.06,0,0,0C452.56,169.89,454.61,177.85,455.42,180.49Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.46,109.81a24.1,24.1,0,0,1,11.74,3.62c15,8.67,27.25,29.84,27.25,47.19,0,9-3.38,15.45-9.25,17.63a13.39,13.39,0,0,1-4.71.81,18.59,18.59,0,0,1-4.38-.56c-.59-.14-1.19-.31-1.81-.51a31,31,0,0,1-5.55-2.54,46.79,46.79,0,0,1-10.32-8.32c-.42-.44-.85-.91-1.27-1.38-.85-1-1.71-2-2.58-3.11s-1.85-2.47-2.72-3.75-1.7-2.64-2.46-4c-5.09-8.87-7.89-18.33-7.89-26.65,0-11.38,5.34-18.45,13.95-18.45h0m0-1.55c-9.19,0-15.5,7.33-15.5,20,0,8.88,3.09,18.69,8.09,27.41.79,1.39,1.64,2.76,2.53,4.08s1.81,2.6,2.78,3.84,1.73,2.16,2.64,3.18c.43.49.87,1,1.31,1.43A48.35,48.35,0,0,0,445,176.79a32.15,32.15,0,0,0,5.84,2.67c.65.21,1.3.4,1.93.55a20.26,20.26,0,0,0,4.75.6,15,15,0,0,0,5.25-.91c6.26-2.32,10.25-9,10.25-19.08,0-17.87-12.54-39.6-28-48.53a25.34,25.34,0,0,0-12.51-3.83Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.54,100.36c-4.36-2.52-7.89-.48-7.89,4.56a17.47,17.47,0,0,0,7.89,13.68c4.36,2.51,7.9.47,7.9-4.56A17.46,17.46,0,0,0,416.54,100.36Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,106.86a.8.8,0,0,1,1.11-.29l2.61,1.51v-3.71a.81.81,0,0,1,1.62,0V109l3.43,2a.8.8,0,0,1,.29,1.1.81.81,0,0,1-.7.41.86.86,0,0,1-.4-.11l-2.62-1.51v3.71a.81.81,0,0,1-1.62,0v-4.65l-3.42-2A.82.82,0,0,1,412,106.86Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.84,86c0,8.87,3.09,18.68,8.1,27.41q1.19,2.08,2.52,4.08t2.78,3.84c.85,1.09,1.74,2.16,2.64,3.18.43.48.88,1,1.31,1.43a48.41,48.41,0,0,0,10.67,8.58,31.54,31.54,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a16.78,16.78,0,0,0,10-.31c6.26-2.31,10.25-9,10.26-19.08,0-17.87-12.55-39.59-28-48.52S343.84,68.17,343.84,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.31,112.34c.21.38.41.75.62,1.11.43.76.88,1.51,1.36,2.24s.77,1.22,1.17,1.83q1.34,2,2.78,3.84a4,4,0,0,0,.26.32l1.5-8.32C355.68,112.43,353.21,112.06,351.31,112.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.29,115.69q.57.91,1.17,1.83,1.34,2,2.78,3.84a4,4,0,0,0,.26.32c.77,1,1.57,2,2.39,2.87l1.29,1.42a48.5,48.5,0,0,0,10.68,8.6,32.21,32.21,0,0,0,5.84,2.67c.65.21,1.29.39,1.93.54a17.93,17.93,0,0,0,7.32.39,13.08,13.08,0,0,0,2.67-.69,13.28,13.28,0,0,0,3.14-1.66c-.31-2.32-.93-4.13-1.95-5C387.12,128,378,118.21,369.48,116c-3.36-.87-6.71-1.84-10.48-2.68C357,112.9,355,113.67,353.29,115.69Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.5,86.39c4.6,5.83,1.32,11.67-.33,17.21-1.91,6.28-2.69,8.65-4.81,9.43,1.36-16.15-2.76-5.83-11.69-10.29a24.79,24.79,0,0,1-8.51-8.7A20,20,0,0,0,357,91.6c-2.2-1.64-3-4.49-1.19-6.76a2.61,2.61,0,0,1,.06-5.17c-2.05-2.38-1.44-6,.29-6.93,1-.59,2-.36,3.25.31a18,18,0,0,0,4.11,1.9c3.61,1,6.8,1.2,10.47,2.08C378.76,78.17,383.8,81,383.5,86.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,109.58c-2.11,1-3.89-1.9-3.89-1.9l-1.05,13.88s-1.58,3.73-12.08,2.64c-2.53-.26-6.84-3.34-1.32-6.94l.21-4.23a19.74,19.74,0,0,1-4.12-1.5c-1.95-1.12-3.24-3-3.91-6.42-1.09-5.43-.56-13,1.45-22.53C362,86,369.12,80.81,375,87.24c-1.61,3.15.71,9,2.81,10.18-.67,2.74-.32,4.06.47,4.35,1.39.51,2.34-1.39,3.16-2.14s3.43-1.37,4.62,2.06S385.27,108.72,383.44,109.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31,113c2.49.58,7.25.38,9.12-1.1a13.94,13.94,0,0,0,3.08-3.66,8.7,8.7,0,0,1-2.73,5.06c-3.82,3-9.59,1.8-9.59,1.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.34,92.07l2.44,2.42a2.1,2.1,0,0,0-.4-2.5A1.26,1.26,0,0,0,370.34,92.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.28,89.05l3-.18a1.82,1.82,0,0,0-1.75-1.63A1.46,1.46,0,0,0,359.28,89.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.38,96.35a1,1,0,0,1-1.29,1A1.73,1.73,0,0,1,369,95.65a1,1,0,0,1,1.29-1A1.72,1.72,0,0,1,371.38,96.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,93.13a1,1,0,0,1-1.29,1,1.74,1.74,0,0,1-1.13-1.73,1,1,0,0,1,1.3-1A1.74,1.74,0,0,1,362,93.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66,93.36l-1.75,8.12-4-2.85C362.47,96.28,364.93,93.86,366.66,93.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,104.26l-4.34.23a2.08,2.08,0,0,0,2.19,2A2.19,2.19,0,0,0,368.07,104.26Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,106.47a2,2,0,0,1-1.08-.24,2.6,2.6,0,0,1,2.35-1.49,2.38,2.38,0,0,1,.81.14A2.29,2.29,0,0,1,365.92,106.47Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387,138.17a13.08,13.08,0,0,0,2.67-.69,13.28,13.28,0,0,0,3.14-1.66,14.05,14.05,0,0,0,1.89-1.65,38.84,38.84,0,0,0-3.84-3.31A17.93,17.93,0,0,0,387,138.17Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,67.58a24.12,24.12,0,0,1,11.74,3.63c15,8.67,27.25,29.83,27.25,47.18,0,9-3.38,15.46-9.25,17.63a13.33,13.33,0,0,1-4.7.81,18.58,18.58,0,0,1-4.39-.55c-.58-.14-1.19-.31-1.81-.52a30.35,30.35,0,0,1-5.55-2.54,46.68,46.68,0,0,1-10.32-8.31c-.41-.45-.85-.92-1.27-1.39-.84-1-1.71-2-2.58-3.11s-1.85-2.47-2.72-3.75-1.7-2.63-2.46-4c-5.09-8.87-7.89-18.33-7.89-26.64,0-11.38,5.35-18.46,13.95-18.46h0m0-1.54c-9.19,0-15.5,7.32-15.5,20,0,8.87,3.09,18.68,8.1,27.41q1.19,2.08,2.52,4.08t2.78,3.84c.85,1.09,1.74,2.16,2.64,3.18.43.48.88,1,1.31,1.43a48.41,48.41,0,0,0,10.67,8.58,31.54,31.54,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a20.2,20.2,0,0,0,4.75.6,14.68,14.68,0,0,0,5.24-.91c6.26-2.31,10.25-9,10.26-19.08,0-17.87-12.55-39.59-28-48.52A25.4,25.4,0,0,0,359.34,66Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.43,58.15c-4.36-2.52-7.9-.48-7.9,4.56a17.44,17.44,0,0,0,7.9,13.67c4.36,2.52,7.89.48,7.89-4.55A17.45,17.45,0,0,0,343.43,58.15Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,64.65a.8.8,0,0,1,1.1-.3l2.62,1.52V62.16a.81.81,0,1,1,1.61,0V66.8l3.43,2a.81.81,0,0,1-.4,1.51.87.87,0,0,1-.41-.11l-2.62-1.51v3.7a.81.81,0,1,1-1.61,0V67.73l-3.43-2A.79.79,0,0,1,338.9,64.65Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.84,251c0,8.87,3.09,18.68,8.1,27.41q1.19,2.08,2.52,4.08t2.78,3.84c.85,1.09,1.74,2.16,2.64,3.18.43.48.88,1,1.31,1.43a48.41,48.41,0,0,0,10.67,8.58,31.84,31.84,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a16.78,16.78,0,0,0,10-.31c6.26-2.31,10.25-9,10.26-19.08,0-17.87-12.55-39.59-28-48.52S343.84,233.15,343.84,251Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.93,263.49c-.15,2.06-.82,5.78,1.6,8.85s3,6.77.42,9.48-1.21,4,.48,6.31,1.57,6.42-2.2,6.73-26.76-10.44-29.13-13.17-3.41-5.13-1.9-7.53,4-3.18,4-6.89-3-6.35-1.73-8.79S386.93,263.49,386.93,263.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,284.23c.39.59.77,1.18,1.19,1.76s1,1.43,1.52,2.14l2.64-8.27c-5.55-1.68-6.55-1-8.13-.29.53,1.07,1.89,3.25,2.64,4.43Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,286l1.52,2.13c0,.05.08.09.11.14.87,1.17,1.77,2.3,2.68,3.38l1.31,1.53c.34.36.67.73,1,1.1l0,0a45.09,45.09,0,0,0,7.2,5.23,33,33,0,0,0,5.84,2.68c.65.21,1.29.39,1.93.53a22.55,22.55,0,0,0,2.67.49,16.6,16.6,0,0,0,4.85-.12c0-.17,0-.34,0-.51.53-11.2-3.33-14.09-3.39-14.11s-1.59-.77-2.5-1.19c-1.81-.82-14.89-3.23-14.89-3.23l-4.24-4.22s-3.89,1.06-6,3.4C356.2,283.26,357,284.55,358,286Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,279.36c.46-3.81,6.37-3,9.16-11.43,1.44-4.36.77-13.1-4.06-15.21-2.2-8.26-11-13.24-19.21-12.87-4.26-.07-7.88,3.4-9.38,7.18-3.11,8.39,1.7,13.9,3.2,16.46.78,1.34,1.94-6,2.49-4.56a22.56,22.56,0,0,1,1.06,3.36,15,15,0,0,0,4.45,5.26C368.9,271.48,373.15,275.33,377.1,279.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,283l1-8.3s2.12,2.09,4.37.46a5.19,5.19,0,0,0,1.77-6.88,3.64,3.64,0,0,0-6.1-.7c-2.12-.13-2.78-3.54-1-6.26,0,0,.85-5.86-3-8.4-2.92-1.93-4.93-1.1-8.24-1.05-2.39-.86-2.63-4.32-5.71-3.82-1.14,1.31-3.09,3.64-2.64,9.09a15.3,15.3,0,0,1-.77,3.44c-1.21,5.54.85,11.81,3.13,13.64a13.55,13.55,0,0,0,5.75,2.89l-.26,2.31h0c-.12,1.16-.38,1.11-1.35.86l-1.46-.37s-2,3,4.91,6.16c10.24,4.68,14.22,1.29,14.22,1.29s-.59-.25-2.37-1.08S376.72,284.57,376.67,283Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.34,269.4l-3.8.08a2.58,2.58,0,0,0,2.34,2.17A1.7,1.7,0,0,0,368.34,269.4Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.05,270.23a1.66,1.66,0,0,0-2.25,1.1,1.94,1.94,0,0,0,1.08.32,1.52,1.52,0,0,0,1.46-1.29Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,253.88l2.82-.42a1.89,1.89,0,0,0-1.89-1.45A1.36,1.36,0,0,0,359.34,253.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.65,259.06l-2.59-2.38a1.31,1.31,0,0,1,2.07-.05A2.06,2.06,0,0,1,371.65,259.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,258.74a1,1,0,0,1-1.24,1.08,1.7,1.7,0,0,1-1.28-1.59,1,1,0,0,1,1.24-1.08A1.7,1.7,0,0,1,361.28,258.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.32,262.6a1,1,0,0,1-1.24,1.08,1.69,1.69,0,0,1-1.27-1.59A1,1,0,0,1,369,261,1.7,1.7,0,0,1,370.32,262.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.23,277.06c4.8,1,9.46.77,10.66-1.19,0,0-.13,2.51-2.13,3.1-2.81.83-8.73-.16-8.73-.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.07,262.56l-.73-.62-.63-.36a25.71,25.71,0,0,0-6.27-2.72c-2-.39-2.78-.11-3.89-.62s-1.64-1.39-3.46-2.8a18.93,18.93,0,0,0-3.87-2.11c-.68-.3-1.35-.56-2-.79l-.59-.2c-.33-.11-.72.19-.73.71a3.09,3.09,0,0,0,.45,1.41,1.6,1.6,0,0,1,.18.52,24.46,24.46,0,0,0,.48,3.49,6,6,0,0,0,1.27,2.3,6.5,6.5,0,0,0,2.18,1.58,6.8,6.8,0,0,0,1.26.46l.1,0a3.61,3.61,0,0,0,1,.09h.16l.11,0,.11,0,.12,0,.11,0,.22-.1a2.66,2.66,0,0,0,.94-.82c.64-.86.66-2.46,1.55-2.25l.11,0,.11.05c1.18.55.88,2.16,1.42,3.65a7.21,7.21,0,0,0,4.09,4.33l.34.15.26.1a5.38,5.38,0,0,0,.63.19l.2.05.19,0,.12,0a3,3,0,0,0,.73,0l.25,0a1.81,1.81,0,0,0,.43-.14,2.33,2.33,0,0,0,.9-.77,14.63,14.63,0,0,0,1-2.79.87.87,0,0,1,.24-.37l.29-.21.17.14,3.11,2.54a3.25,3.25,0,0,1,1.49-.4Zm-13.94-2.12a3.35,3.35,0,0,1-.23.54l0,0,0,.05,0,0,0,.06-.09.12-.08.1,0,0-.07.06-.06.06h0c-.54.46-1.45.66-3-.07a5.15,5.15,0,0,1-1.4-1,4,4,0,0,1-.55-.63,6,6,0,0,1-1-2.88c-.12-.92-.21-2.67.23-2.85a1.12,1.12,0,0,1,.49-.06h0l.21,0,.13,0,.11,0h.1l.11,0a.83.83,0,0,1,.21.06l.23.07.25.09.14,0,.11.05.31.13.11.05.1,0c.28.13.57.29.88.47a9.1,9.1,0,0,1,3,2.69A3.85,3.85,0,0,1,362.13,260.44Zm11.64,5s0,0,0,0a.14.14,0,0,1,0,.06l-.11.3a1.5,1.5,0,0,0-.09.18l-.16.29a.86.86,0,0,0-.07.1l0,.05-.05.06-.06.08-.07.08-.09.08-.1.08c-.54.42-1.39.59-2.79,0a6,6,0,0,1-2.72-2.25,5.16,5.16,0,0,1-.76-2.08c-.14-1-.17-2.16.26-2.5a1.2,1.2,0,0,1,.61-.17h.72a8,8,0,0,1,.88.14l.34.08c.29.07.59.16.89.26l.2.08a7.81,7.81,0,0,1,3.48,2.21C374.41,263.2,374,264.73,373.77,265.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.21,263.55l4,2.71,1.26-4.69c-.15-.84-.32-1.55-1-1.88l-.11-.05-.11,0h0Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.3,303.24a16.6,16.6,0,0,0,4.85-.12,13.72,13.72,0,0,0,5.94-2.58c-3.4-9.18-4-9.92-9.3-12h0C379.45,292.64,381.49,300.6,382.3,303.24Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,232.56a24.12,24.12,0,0,1,11.74,3.63c15,8.67,27.25,29.83,27.25,47.18,0,9-3.38,15.46-9.25,17.63a13.33,13.33,0,0,1-4.7.81,18.58,18.58,0,0,1-4.39-.55c-.58-.14-1.19-.31-1.81-.52a30.35,30.35,0,0,1-5.55-2.54,46.68,46.68,0,0,1-10.32-8.31c-.41-.45-.85-.92-1.27-1.39-.84-.95-1.71-2-2.58-3.11s-1.85-2.47-2.72-3.75-1.69-2.63-2.46-4c-5.09-8.87-7.89-18.33-7.89-26.64,0-11.38,5.35-18.46,13.95-18.46h0m0-1.54c-9.19,0-15.5,7.32-15.5,20,0,8.87,3.09,18.68,8.1,27.41q1.19,2.08,2.52,4.08t2.78,3.84c.85,1.09,1.74,2.16,2.64,3.18.43.48.88,1,1.31,1.43a48.41,48.41,0,0,0,10.67,8.58,31.84,31.84,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a20.2,20.2,0,0,0,4.75.6,14.68,14.68,0,0,0,5.24-.91c6.26-2.31,10.25-9,10.26-19.08,0-17.87-12.55-39.59-28-48.52A25.4,25.4,0,0,0,359.34,231Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.43,223.11c-4.37-2.51-7.9-.47-7.9,4.56a17.44,17.44,0,0,0,7.9,13.68c4.36,2.52,7.89.48,7.89-4.56A17.47,17.47,0,0,0,343.43,223.11Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.89,229.62a.82.82,0,0,1,1.11-.3l2.62,1.51v-3.71a.81.81,0,0,1,1.61,0v4.65l3.43,2a.82.82,0,0,1,.3,1.11.8.8,0,0,1-.7.4.77.77,0,0,1-.41-.11l-2.62-1.51v3.71a.81.81,0,1,1-1.61,0V232.7l-3.43-2A.81.81,0,0,1,338.89,229.62Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,293.23c0,8.87,3.09,18.68,8.09,27.41.79,1.39,1.64,2.75,2.53,4.08s1.81,2.6,2.78,3.84c.85,1.09,1.73,2.16,2.64,3.18.43.48.87,1,1.31,1.43A48.3,48.3,0,0,0,445,341.75a32.15,32.15,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a16.81,16.81,0,0,0,10-.31c6.26-2.31,10.25-9,10.25-19.08,0-17.87-12.54-39.59-28-48.52S417,275.36,417,293.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.42,319.53c.22.38.41.75.63,1.11.42.76.88,1.51,1.35,2.24s.78,1.22,1.18,1.83c.88,1.33,1.81,2.61,2.77,3.85.09.1.17.21.26.32l1.51-8.33C428.8,319.62,426.33,319.26,424.42,319.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.4,322.88c.39.61.78,1.22,1.18,1.83.88,1.33,1.81,2.61,2.77,3.85.09.1.17.21.26.32.78,1,1.57,1.95,2.4,2.86.42.47.86,1,1.29,1.42a48.22,48.22,0,0,0,10.67,8.6,32.84,32.84,0,0,0,5.84,2.67c.66.21,1.3.39,1.94.55a18.08,18.08,0,0,0,7.32.38,13.25,13.25,0,0,0,2.67-.69,13.47,13.47,0,0,0,3.14-1.66c-.31-2.32-.93-4.13-2-5-3.68-2.91-12.79-12.65-21.32-14.82-3.36-.86-6.71-1.84-10.48-2.68C430.06,320.09,428.1,320.86,426.4,322.88Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.4,322.88c.39.61.78,1.22,1.18,1.83.88,1.33,1.81,2.61,2.77,3.85.09.1.17.21.26.32.78,1,1.57,1.95,2.4,2.86.42.47.86,1,1.29,1.42a48.22,48.22,0,0,0,10.67,8.6,32.84,32.84,0,0,0,5.84,2.67c.66.21,1.3.39,1.94.55a18.08,18.08,0,0,0,7.32.38,13.25,13.25,0,0,0,2.67-.69,13.47,13.47,0,0,0,3.14-1.66c-.31-2.32-.93-4.13-2-5-3.68-2.91-12.79-12.65-21.32-14.82-3.36-.86-6.71-1.84-10.48-2.68C430.06,320.09,428.1,320.86,426.4,322.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.76,293.72a4.71,4.71,0,0,1-.29.72c3.74,1.71,6.69,6.1,2.09,8.87,2.79,2.28,1.55,5.6-1.42,6.92-.52.62-.08,1.53,0,2.33a2.49,2.49,0,0,1-3.29,2.57c.21,1.34-.75,3.43-2.46,3.38l.28-3.64s.46-3.2-1.18-3.91c-1.43-.33-2.89.28-4.33.33-5.27.58-9.67-3.16-12.69-7.08a1.41,1.41,0,0,0-.86-.73c-1.72-1-1.83-3.29-1.28-5a3.17,3.17,0,0,1-3.77-5.1,2.52,2.52,0,0,1-3-3.89,1.35,1.35,0,0,0,2.23,1.29c.7-.67.48-1.81.22-2.75a2.7,2.7,0,0,1,.33-2.72c.82-1.41,3.84-2.24,5.71-1.16a4.07,4.07,0,0,1,3.08-4.28c2.57-.85,4.76,1,7,1.75,3.83-1.4,8.29.79,8.34,5.16C456.64,287,459.17,289.54,457.76,293.72Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.56,316.77c-2.12,1-3.89-1.9-3.89-1.9l-1.06,13.88s-1.09,2.75-8.2,2.63c-5.52-.1-9.5-3.33-5.2-6.93l.22-4.23a19.54,19.54,0,0,1-4.12-1.5c-1.95-1.12-3.51-4.67-4.18-8-1.09-5.43-.3-11.42,1.72-20.91,3.27,3.42,10.38-1.77,16.29,4.66-1.61,3.15.7,9,2.81,10.18-.68,2.74-.33,4.06.47,4.35,1.39.52,2.34-1.39,3.15-2.14s3.44-1.37,4.63,2.06S458.39,315.91,456.56,316.77Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.43,320.22c1.11.2,5.31.32,6.8-.31a9.58,9.58,0,0,0,5.76-5.38,7.86,7.86,0,0,1-4.06,6.25,13.52,13.52,0,0,1-8.62,1.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.61,298.32l2.44,2.42a2.13,2.13,0,0,0-.4-2.5A1.26,1.26,0,0,0,442.61,298.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,296.24l3-.18a1.81,1.81,0,0,0-1.74-1.63A1.45,1.45,0,0,0,432.4,296.24Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,303.49a1,1,0,0,1-1.29,1,1.74,1.74,0,0,1-1.13-1.73,1,1,0,0,1,1.29-1A1.75,1.75,0,0,1,444,303.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12,300.32a1,1,0,0,1-1.29,1,1.73,1.73,0,0,1-1.13-1.72,1,1,0,0,1,1.29-1A1.75,1.75,0,0,1,435.12,300.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.63 299.97 437.87 308.08 433.89 305.24 439.63 299.97",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.19,311.45l-4.35.23a2.08,2.08,0,0,0,2.19,2A2.19,2.19,0,0,0,441.19,311.45Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,313.66a2,2,0,0,1-1.07-.24,2.6,2.6,0,0,1,2.35-1.49,2.46,2.46,0,0,1,.81.14A2.29,2.29,0,0,1,439,313.66Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.07,345.36a13.25,13.25,0,0,0,2.67-.69,13.47,13.47,0,0,0,3.14-1.66,14.05,14.05,0,0,0,1.89-1.65,40.18,40.18,0,0,0-3.85-3.31A18,18,0,0,0,460.07,345.36Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432.46,274.78a24.1,24.1,0,0,1,11.74,3.62c15,8.67,27.25,29.83,27.25,47.18,0,9-3.38,15.46-9.25,17.63a13.39,13.39,0,0,1-4.71.82,18.59,18.59,0,0,1-4.38-.56c-.59-.14-1.19-.31-1.81-.52a30.35,30.35,0,0,1-5.55-2.54,46.22,46.22,0,0,1-10.32-8.31c-.42-.45-.85-.92-1.27-1.39-.85-.95-1.71-2-2.58-3.1s-1.85-2.48-2.72-3.76-1.7-2.63-2.46-4c-5.09-8.88-7.89-18.34-7.89-26.65,0-11.38,5.34-18.45,13.95-18.45h0m0-1.55c-9.19,0-15.5,7.32-15.5,20,0,8.87,3.09,18.68,8.09,27.41.79,1.39,1.64,2.75,2.53,4.08s1.81,2.6,2.78,3.84c.85,1.09,1.73,2.16,2.64,3.18.43.48.87,1,1.31,1.43A48.3,48.3,0,0,0,445,341.75a32.15,32.15,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a19.75,19.75,0,0,0,4.75.6,14.74,14.74,0,0,0,5.25-.91c6.26-2.31,10.25-9,10.25-19.08,0-17.87-12.54-39.59-28-48.52a25.34,25.34,0,0,0-12.51-3.83Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.54,265.34c-4.36-2.52-7.89-.48-7.89,4.56s3.53,11.16,7.89,13.67,7.9.48,7.9-4.55A17.46,17.46,0,0,0,416.54,265.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,271.84a.8.8,0,0,1,1.11-.29l2.61,1.51v-3.71a.81.81,0,0,1,1.62,0V274l3.43,2a.8.8,0,0,1,.29,1.1.81.81,0,0,1-.7.41.86.86,0,0,1-.4-.11l-2.62-1.51v3.71a.81.81,0,0,1-1.62,0v-4.65l-3.42-2A.82.82,0,0,1,412,271.84Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.84,170.5c0,8.87,3.09,18.68,8.1,27.41q1.19,2.09,2.52,4.08t2.78,3.84c.86,1.09,1.74,2.16,2.65,3.18.42.48.87,1,1.3,1.43A48.12,48.12,0,0,0,371.86,219a31.84,31.84,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a16.86,16.86,0,0,0,10-.3c6.26-2.32,10.25-9,10.26-19.09,0-17.87-12.55-39.59-28-48.52S343.84,152.63,343.84,170.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.31,196.8c.21.38.41.75.62,1.11.43.77.89,1.51,1.36,2.24s.78,1.22,1.17,1.83q1.34,2,2.78,3.85c.09.1.16.21.26.32l1.51-8.33C355.68,196.89,353.21,196.53,351.31,196.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.29,200.15c.38.61.78,1.22,1.17,1.83q1.34,2,2.78,3.85c.09.1.16.21.26.32.77,1,1.57,1.95,2.39,2.86.43.48.87,1,1.3,1.42a48.22,48.22,0,0,0,10.67,8.6,32.52,32.52,0,0,0,5.84,2.67c.65.21,1.29.39,1.93.55a18.09,18.09,0,0,0,7.32.38,13.08,13.08,0,0,0,2.67-.69,12.92,12.92,0,0,0,3.14-1.66c-.3-2.32-.93-4.13-1.95-5-3.69-2.91-5.79-4.75-7.64-6.08a27.68,27.68,0,0,0-13.69-8.73c-3.35-.87-6.71-1.85-10.47-2.69C357,197.36,355,198.13,353.29,200.15Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.52,169.09c3.67,6,2.32,13.85-.35,19-1.2,2.3-3,6.57-4,9.17,0,0-6.44,2.41-20.57-18-2.55-3.69-1.1-12.58,2.33-15.87C365.77,158.71,376.35,157.6,383.52,169.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,194c-2.11,1-3.89-1.9-3.89-1.9L378.5,206s0,1.8-3.66,3.06c-2.41.84-7.41.35-10.25,2.8-1.2-2.64-2.16-7.21.51-10.16l.21-4.23a19.74,19.74,0,0,1-4.12-1.5,8.92,8.92,0,0,1-4.66-6.25,27,27,0,0,1-.57-6.58,87.37,87.37,0,0,1,1.91-12.72c.27-1.23,1.61-4.16,2.79-4.61,2.82-1.06,2.49,3.31,5.76,4.42S379,169.09,377,173.11a18.54,18.54,0,0,0,.81,10.86,7.54,7.54,0,0,0,1.05,1.92c.92,1.17,1.75-1,2.57-1.8s3.43-1.37,4.62,2.06S385.27,193.18,383.44,194Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31,197.49c2.5.58,7.25.38,9.12-1.1a13.94,13.94,0,0,0,3.08-3.66,8.7,8.7,0,0,1-2.73,5.06c-3.82,3-9.59,1.8-9.59,1.8Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,183.16c.29,2.07-2,7.06-5.57,6.67s-4.24-2.68-7.39-3.51c-2.8-.73-4.57.19-6-.38s-2.66-2.78-2.66-2.78-.8,6.41.7,9.57c2,4.2,7.25,5.12,10.4,5.41a11.39,11.39,0,0,0,7.85-1.86c2-1.45,3.2-3.94,4.13-6.45s2.42-5.74,2.42-5.74l-3.75-1.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.35,176.54l2.43,2.41a2.1,2.1,0,0,0-.4-2.5A1.25,1.25,0,0,0,370.35,176.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.28,173.51l3-.17a1.82,1.82,0,0,0-1.75-1.63A1.45,1.45,0,0,0,359.28,173.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.38,180.82a1,1,0,0,1-1.29,1,1.74,1.74,0,0,1-1.12-1.73,1,1,0,0,1,1.29-1A1.72,1.72,0,0,1,371.38,180.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,177.59a1,1,0,0,1-1.29,1,1.75,1.75,0,0,1-1.13-1.73,1,1,0,0,1,1.3-1A1.74,1.74,0,0,1,362,177.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66,177.83l-1.75,8.11-4-2.85C362.47,180.74,364.93,178.32,366.66,177.83Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,189.09l-4.35.23a2.08,2.08,0,0,0,2.19,2A2.19,2.19,0,0,0,367.15,189.09Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,191.3a2.08,2.08,0,0,1-1.07-.23,2.59,2.59,0,0,1,2.35-1.5,2.46,2.46,0,0,1,.81.14A2.29,2.29,0,0,1,365,191.3Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.59,211.88c1.57-.63,5.71-1.51,6-.24.24.89.91,4.1,2.08,4.34a10.61,10.61,0,0,0,8.54-3.21,6.49,6.49,0,0,0,1.92-3.53s-1.38-3.55-2.23-5.24-1.08-2.67-2-3l-.26,2.92a7.33,7.33,0,0,1-2.85,2.67C373,208,367.41,208.84,364.59,211.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,211.88c-.86-1.19-2.27-5.54-3-5.59-1.53-.08-2.58.89-2.58,0s1.14-2.55,2.52-4.83c1.06-1.74,2.75-3,3.75-2.88l-.24,4a9.58,9.58,0,0,0-.8,3.31A14.16,14.16,0,0,0,364.59,211.88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387,222.63a13.08,13.08,0,0,0,2.67-.69,12.92,12.92,0,0,0,3.14-1.66,14.05,14.05,0,0,0,1.89-1.65,38.84,38.84,0,0,0-3.84-3.31A17.93,17.93,0,0,0,387,222.63Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,152.05a24.1,24.1,0,0,1,11.74,3.62c15,8.67,27.25,29.83,27.25,47.18,0,9-3.38,15.46-9.25,17.63a13.34,13.34,0,0,1-4.7.82,18.46,18.46,0,0,1-4.38-.56c-.59-.14-1.2-.31-1.82-.52a30.29,30.29,0,0,1-5.55-2.54,46.68,46.68,0,0,1-10.32-8.31c-.41-.45-.85-.92-1.27-1.39-.84-.95-1.71-2-2.58-3.1s-1.85-2.48-2.72-3.76-1.69-2.63-2.45-4c-5.1-8.88-7.9-18.34-7.9-26.65,0-11.38,5.35-18.45,13.95-18.45h0m0-1.55c-9.19,0-15.5,7.33-15.5,20,0,8.87,3.09,18.68,8.1,27.41q1.19,2.09,2.52,4.08t2.78,3.84c.86,1.09,1.74,2.16,2.65,3.18.42.48.87,1,1.3,1.43A48.12,48.12,0,0,0,371.86,219a31.84,31.84,0,0,0,5.84,2.67c.65.22,1.3.4,1.93.55a19.72,19.72,0,0,0,4.75.61,14.91,14.91,0,0,0,5.24-.91c6.26-2.32,10.25-9,10.26-19.09,0-17.87-12.55-39.59-28-48.52a25.4,25.4,0,0,0-12.52-3.83Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.43,147.23c-4.36-2.51-7.9-.47-7.9,4.56a17.46,17.46,0,0,0,7.9,13.68c4.36,2.52,7.89.48,7.89-4.56A17.45,17.45,0,0,0,343.43,147.23Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,153.74a.8.8,0,0,1,1.1-.3l2.62,1.51v-3.71a.81.81,0,1,1,1.61,0v4.64l3.43,2A.82.82,0,0,1,348,159a.8.8,0,0,1-.7.4.77.77,0,0,1-.41-.11l-2.62-1.51v3.71a.81.81,0,1,1-1.61,0v-4.64l-3.43-2A.79.79,0,0,1,338.9,153.74Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,212.69c0,8.88,3.09,18.69,8.1,27.41.78,1.39,1.63,2.76,2.52,4.08s1.81,2.6,2.78,3.84,1.73,2.16,2.64,3.18c.43.49.87,1,1.31,1.43A48.35,48.35,0,0,0,445,261.22a31.92,31.92,0,0,0,5.85,2.67c.64.21,1.29.4,1.92.55a17,17,0,0,0,10-.31c6.26-2.32,10.25-9,10.26-19.08,0-17.87-12.55-39.6-28-48.53S417,194.82,417,212.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.5,221.63c.79,3.21.39,6.58-.12,9.84s-1.12,6.56-.78,9.85c.07.65.14,1.42-.37,1.84a1.31,1.31,0,0,1-1.62-.16,3.83,3.83,0,0,1-.89-1.51c-.2,2.37-.39,4.73-.59,7.1a4.27,4.27,0,0,1-.66,2.31c-.83,1-2.42,1-3.67.63a10.09,10.09,0,0,1-6.13-6.71,19.78,19.78,0,0,1-.21-9.34,38.45,38.45,0,0,1,4.35-12,37.14,37.14,0,0,0,3.22-6.19,6.85,6.85,0,0,1,1.09-2.45c.3-.35.58-.24,1-.08a8.61,8.61,0,0,1,1.09.56,8.76,8.76,0,0,1,1.88,1.61,10.25,10.25,0,0,1,1.43,2.08,11.14,11.14,0,0,1,.93,2.36A2.81,2.81,0,0,1,460.5,221.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.06,240.1c.78,1.39,1.63,2.76,2.52,4.08s1.81,2.6,2.78,3.84l2.49-7.17h0C429.48,239.83,427.27,239.31,425.06,240.1Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.74,243.05q1.33,2,2.78,3.84c.85,1.1,1.74,2.16,2.64,3.18.43.48.88,1,1.31,1.43a48.35,48.35,0,0,0,10.66,8.59,31.92,31.92,0,0,0,5.85,2.67c.65.21,1.3.4,1.93.54a32,32,0,0,1,3-13.21s-2.33-1.23-6.76-3.65c-.05,0-.11-.07-.15-.11-3.53-2.42-5.92-2-12.42-4.77-.11-.05.79-.52.68-.57L433,239.72h0A47.09,47.09,0,0,0,427.74,243.05Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.39,239c.53-2,3-3.42,5.3-6.85s5.31-11.14.58-14.74c.87-4.62-2.83-10.3-7.88-12.56-6.65-3-14.41-2.58-18.91,3.11-5.32,6.72.18,13.11.18,13.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.29,231.65a9.12,9.12,0,0,0,2,3.9c1.15,1.37,2.73,2.11,5.35,3l-.08,1.79,0,1.15-.05,1.19-.05,2.06s-3.15,3.73-3.39,6.45c.43.49.87,1,1.31,1.43A30.46,30.46,0,0,0,449,247.86v-.29l.14-3,.33-7.32.06-2.07a1.89,1.89,0,0,0,.33.78,3,3,0,0,0,1.09.9,3.13,3.13,0,0,0,2.66.15l.19-.1a1,1,0,0,0,.28-.14.83.83,0,0,0,.22-.14l.19-.13h0a1.39,1.39,0,0,0,.19-.15,5.3,5.3,0,0,0,1.57-6.11c-.65-1.55-2.41-2.92-3.73-2.39s-1.5,1.35-2.07,2.29-3.29-1.93-1.42-6.8c-2.23-1.76-3.28-5.85-2.69-7.81-1-3.54-7.54-4-8.69-2.65-1-2.23-.85-3.57-2.71-3s-5,1.82-6.09,9.52A32.25,32.25,0,0,0,429.29,231.65Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.87,230.93,437,231a2.57,2.57,0,0,0,2.55,2.27C440.59,233.23,441.06,232.23,440.87,230.93Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.41,233.07a1.7,1.7,0,0,1,2.29-1.39,1.11,1.11,0,0,1,.19.09,1.5,1.5,0,0,1-1.38,1.54A2.11,2.11,0,0,1,438.41,233.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.22 220.62 436.32 228.27 432.66 225.78 437.22 220.62",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.25,221a1,1,0,0,1-1.24,1.08,1.7,1.7,0,0,1-1.28-1.58A1,1,0,0,1,432,219.4,1.69,1.69,0,0,1,433.25,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.33,224.06a1,1,0,0,1-1.24,1.08,1.7,1.7,0,0,1-1.28-1.59,1,1,0,0,1,1.24-1.08A1.71,1.71,0,0,1,442.33,224.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.6,238.56a17.24,17.24,0,0,0,7.81-.37,7.63,7.63,0,0,0,3.67-3s.27,2.47-3.43,4.2c-2.89,1.36-8.12,1-8.12,1Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.88,217.2l2.79.18a2.25,2.25,0,0,0-1.83-1.64C431.07,215.69,430.64,216.35,430.88,217.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.13,219.69l3.06,2a2.17,2.17,0,0,0-1.05-2.3C441.3,218.86,440.4,219,440.13,219.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.94,209.59c-.56,3,3,10.09,7.75,13.29s7.8,2.59,7.8,2.59.56-9.72-4.16-13.39S434.94,209.59,434.94,209.59Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.82,263.89c.64.21,1.29.4,1.92.55a17,17,0,0,0,10-.31,10.74,10.74,0,0,0,3.1-2.45c-3.43-8.12-5.25-9.67-9.91-11.59h0C452.75,252.41,451.33,260.31,450.82,263.89Z",
    style: {
      fill: "#ffbda7"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432.46,194.24a24.1,24.1,0,0,1,11.74,3.62c15,8.67,27.25,29.84,27.25,47.19,0,9-3.38,15.45-9.25,17.63a13.39,13.39,0,0,1-4.71.81,18.59,18.59,0,0,1-4.38-.56c-.58-.14-1.19-.31-1.81-.51a30.35,30.35,0,0,1-5.55-2.54,46.79,46.79,0,0,1-10.32-8.32c-.42-.44-.85-.91-1.27-1.38-.85-1-1.71-2-2.58-3.11s-1.85-2.47-2.72-3.75-1.7-2.64-2.46-4c-5.09-8.87-7.89-18.33-7.89-26.65,0-11.38,5.34-18.45,13.95-18.45h0m0-1.55c-9.19,0-15.5,7.33-15.5,20,0,8.88,3.09,18.69,8.1,27.41.78,1.39,1.63,2.76,2.52,4.08s1.81,2.6,2.78,3.84,1.73,2.16,2.64,3.18c.43.49.87,1,1.31,1.43A48.35,48.35,0,0,0,445,261.22a31.92,31.92,0,0,0,5.85,2.67c.64.21,1.29.4,1.92.55a20.26,20.26,0,0,0,4.75.6,15,15,0,0,0,5.25-.91c6.26-2.32,10.25-9,10.26-19.08,0-17.87-12.55-39.6-28-48.53a25.34,25.34,0,0,0-12.51-3.83Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.54,189.46c-4.36-2.52-7.89-.48-7.89,4.56s3.53,11.16,7.89,13.67,7.9.48,7.9-4.55A17.46,17.46,0,0,0,416.54,189.46Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,196a.82.82,0,0,1,1.11-.3l2.62,1.52v-3.71a.81.81,0,1,1,1.61,0v4.64l3.43,2a.81.81,0,0,1-.41,1.51.86.86,0,0,1-.4-.11L417.35,200v3.7a.81.81,0,1,1-1.61,0V199l-3.43-2A.8.8,0,0,1,412,196Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307,431.88c0-.22-1.7-12.68-1.7-12.68s3.23,1.88,10.73,1.83c3.81,0,8.6-3,8.6-3s-.32,8.62-.15,11.87c.86-.23,1.07,1.8,2.51,2.58,2.48,1.35,7.19,1.61,11.65,1.88,1.19.07,2.53,0,3.76.07h.07c3.72.74,6.83,3.89,2.21,6s-11.2,1.71-17.27,1.26C320.11,441.23,306.46,439.12,307,431.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.56,441a7.37,7.37,0,0,1-.21,3.88c-.4,1.34-4.68,5.34-11.22,7s-14,.47-17.64.8-7.22,1.72-11.49,1.93-10.05-.06-12.41-3.83a4.43,4.43,0,0,1,0-3.35C305.4,446.92,357.56,441,357.56,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,428.64c.5-1.37,1.9,1.69,2.86,2,2.85.94,7.17.9,11.67,1.24,5.68.44,12.31-.31,15.83,1.72s4.05,6.48-2.14,11.2c-1.8,1.36-3.81,3.17-5.75,3.89-6.44,2.38-13.13.94-17.4,1.17-5.56.29-9.39,3-14.41,2.59-6.5-.49-9.84-2-10.51-5.68s1.14-7.33,1.08-11.51c0-2.86.21-3.7,1.45-3.58,0,0,.21,1,2.9,1.74,4.81,1.37,6.06-.49,10.73,4.66,1.43,1.58,2.48.87,2.75.59.92-.93,1.34-2.46,1.23-5C324.5,431.81,324.4,430.55,324.29,428.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.76,448.69s2.46-14.41-5.67-16.69l-1.06-.06s.19-1,3.42-1.17c6.22-.36,10.11.49,12.67,3.21a8.08,8.08,0,0,1,1.49,6.89C356.75,443.66,353.49,446.81,346.76,448.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,440s-.44-6.73-5.13-8.24a5,5,0,0,0-2.41-.15s5.24,1.3,5.75,8.4c0,0,.11.5,1,.51C342.2,440.56,342.72,440.59,342.69,440Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.42,431.41s.09-.15,1-.07a4.64,4.64,0,0,1,1.19.23,8.5,8.5,0,0,1,4.49,8.5s.08.52-.81.4-1-.57-1-.57S336.75,434,331.42,431.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,430.88s.22-.15,1,0c.95.18,1.12.41,1.12.41s4.42,3.15,3.48,8.2c0,0-.06.55-1,.36s-.77-.7-.77-.7A8.3,8.3,0,0,0,328,430.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,401.44c.66-1.3,1.36-2,2.15-3.84,1.58-3.61,2.6-7.83,6-18.89l18.71,8.81s-13.86,22.24-14,24.6C248.56,432.57,237,401.44,237,401.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,407.19c.16-2.07,3.24-4.19,4.59-5.18s1.09-2.86,2.38-3.28c.83-.27,2.26-.09,5.22.67,3.28.84,6.19,3.48,6.77,5.5.33,1.17-.13,2.83-.59,4.38a3.6,3.6,0,0,0-.07,1.55c.18.52.46.48.72-.14.37-.81.79-1.65,1.25-2.49a7.08,7.08,0,0,1,.44,2c0,.75,0,1.46-1.22,3.14a5.4,5.4,0,0,0-1.21,3.56,51.39,51.39,0,0,0,.14,5.95c.08,3.59.52,3.54.52,3.54s5.79-1.45,9.93.77a4.89,4.89,0,0,1,2.69,5.59s-.66,3.89-6,5.09c0,.07-2.9,1-2.92,1a9.86,9.86,0,0,1-6.5.2,6.36,6.36,0,0,1-.65-.28c-3.62-1.84-12.58-6.63-12.47-7.22a7.33,7.33,0,0,0-.08-1.81c-.08-1.41-.17-2.82-.27-4.22S231.29,407.38,231.31,407.19Z",
    style: {
      fill: "#37474f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.3,408.29c-1.59.73-1,5.34.27,9.75s1.86,5.93,1.51,9.67-.58,5.4.94,6.69,13.33,6.36,13.33,6.36a45.71,45.71,0,0,1-3.22-13.8c-.68-8.2-1.45-13.47-5.29-17S230.3,408.29,230.3,408.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.87,432.77s-2.12,4.84-11.59,5.69c-5.18.47-6.3-1.9-6.93-8.25-.65-6.52-1.28-15.15-3.86-18.91s-7-4.94-8.55-4.47a3.46,3.46,0,0,0-1.64,1.46,8.6,8.6,0,0,1,6.89,2.5c3.37,3.12,4.27,10,4.71,16.29s1,13.55,5.88,14.09,11.29-1.69,14.35-4.6A3.35,3.35,0,0,0,262.87,432.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75,426.32c3.7,1.46,5.09,6.77,4.81,9.69a6,6,0,0,1-.49,2.05,11.67,11.67,0,0,0,5.66-1.56c3-1.67,3.81-3.21,3.7-4.8s-1.67-5.12-6.44-5.74S249.75,426.32,249.75,426.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,424.09a3.76,3.76,0,0,1,.63,1.42,2.56,2.56,0,0,1-1.77,2.92c-.72.22-.93-1.14-.16-1.54A2.92,2.92,0,0,0,249.78,424.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.57,419.66a2.29,2.29,0,0,1,.25,1.36,2.7,2.7,0,0,1-2,2.26c-.47.1-.39-1.15,0-1.32A4,4,0,0,0,249.57,419.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,414.69a4.71,4.71,0,0,1-.21,2.07,3.84,3.84,0,0,1-2.37,1.56c-.73,0-.53-1.31-.08-1.56C248.1,416.34,249.76,415.37,250,414.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.87,399.6s18.57-30.8,27.34-46.69c1.84-3.33,2.34-6.24,3.17-10.19.89-4.2,5.3-27.88,5.3-27.88l6.12,36.59A76.69,76.69,0,0,0,297.27,365a131.24,131.24,0,0,0,2.17,25.18c3.3,17.66,5.48,30,5.48,30,1.28.87,5.69,2.59,11.21,1.86a26.32,26.32,0,0,0,8.86-3.42s.87-28.95,1.13-39.88.15-27.67.35-34.87c.36-13,0-13.6-.43-34.87-.41-22.07-2.61-55.09-2.61-55.09l-60.17-.63s-2.07,6.73-2,30.51c0,18.57-1.11,55.95-1.11,55.95a64,64,0,0,0-11.48,23.58c-2.24,8.79-5,20-7.27,27.5C246.42,390.52,254.92,395.46,256.87,399.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.73,315l-4.07-24.44s-8.13-.42-18.09-8.29c0,0,1.47,7.23,15.43,11.85l3.91,23.64-2.05,22.64S292.68,315.49,292.73,315Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.34,412.54c-4,2.12-17.24,3.44-21.88.67L305,422.4s2.79,1.76,9.61,1.33c7.53-.48,10.43-2.42,10.43-2.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.11,392.94,256.87,400a20.1,20.1,0,0,0-7.76-6.61c-6.05-2.72-8.06-2.33-8.06-2.33l2.46-8.52A17.43,17.43,0,0,1,254.08,385C260.69,388.88,261.11,392.94,261.11,392.94Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-83"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "300.23 172.18 298.19 187.11 277.93 186.07 280.12 169.91 300.23 172.18",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.3,144.28c1.56,2,6.41,8,6.6,9.1l-4,2.43Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,129.27c6.27-.67,10.33,3.77,12.15,17.1a34.71,34.71,0,0,1,1.43,3.34c2.51,8.55,1.11,16.7-.34,18.87-3.63,2.91-7.66,4-13.51,3.5-4.45-.37-15.81-1.73-21.57-7.74-6.78-7.08-10.2-17.74-5.39-23.27C276.58,133.28,293.58,129.64,297,129.27Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,168.58c-.8,1.19-6.47,4.14-10.07,4.36v-2.8A38.94,38.94,0,0,0,310.27,168.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27,152.63a1.17,1.17,0,0,1-2.09.35,15.63,15.63,0,0,0-2.29-2.65A5.72,5.72,0,0,0,290,149c-5.26.4-4,7.33-1.39,9.74,4.22,4,6.47.54,6.47.54s3,6.7-1.39,10.61c0,0-7.63,3.3-13.62,1.44-4.49-4.83-7.49-7.88-10.5-12-7.15-9.85-7.16-19.59-2.58-22.37-.25-3.5,1.64-8.75,8.81-11.78,6.84-2.89,11.42-2.61,16.36-2.33s11,2.53,15.61-1.31a9.4,9.4,0,0,1-.76,8.57,3.11,3.11,0,0,1,2.68,5.6,2.44,2.44,0,0,1,1.12,2.89,3,3,0,0,1-2.57,1.9,13,13,0,0,1-3.11-.2c-1.44,4-6,5.45-8.7,5.28.07,0,.42.55.47.63a6.12,6.12,0,0,1,.43.69,8.51,8.51,0,0,1,1,4.75A3,3,0,0,1,298.27,152.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,178.22c-7.53-.35-15,1.88-19.58,12.36-4.32,9.92-10.41,24.23-12.64,31.43-1.09,3.52-3.09,6.67,3.47,12.86a104,104,0,0,0,20.09,14.32L273,235.08l-10.3-9.87,4.54-9.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.72,225.21a13.42,13.42,0,0,1-6.1,5.15c2.89.7,6.07-2.41,7-4.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,180.47c-5.25,2.94-9.25,12.76-8.86,21,.24,5.19,2.07,18.6,3.62,30.44.49,3.74-1,10-1.68,17.61-.51,5.62-1.15,11.55-1.15,11.55s7.61,8.76,27,9.9c24.69,1.45,36.65-5,36.65-5s-.87-19.68-1.46-35.61c-.89-23.63-.94-30.54-4.63-38.59-1.22-2.37-2.5-7.67-6.52-8.71-3.19-.83-10.54-2.59-13.45-3-4.78,1.23-17.16,1.34-20.22-1.28l.05-.68C273.66,178,272.91,178.65,269.66,180.47Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.66,180.47c-5.25,2.94-9.25,12.76-8.86,21,.24,5.19,2.07,18.6,3.62,30.44.49,3.74-1,10-1.68,17.61-.51,5.62-1.15,11.55-1.15,11.55s7.61,8.76,27,9.9c24.69,1.45,36.65-5,36.65-5s-.87-19.68-1.46-35.61c-.89-23.63-.94-30.54-4.63-38.59-1.22-2.37-2.5-7.67-6.52-8.71-3.19-.83-10.54-2.59-13.45-3-4.78,1.23-17.16,1.34-20.22-1.28l.05-.68C273.66,178,272.91,178.65,269.66,180.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.6,163.56c2.71-3.4,4.16-4.82,5.61-5.68s6.38-4.6,8.36-5.69c1.25-.68,2.36,1.31,1,3.23-1,1.47-4.05,3.86-5.34,5.07s-3.29,5.58-3.29,5.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,208.88c-2.85,1.6-5.67,1.18-15.35.67-6.91-.37-16.47-.65-32.72-2.16-6.08-6.08-7.54-16.71-1.49-23.22,6.32-1.46,25.46,6.22,45.91,5.76,0,0,20.15-9.21,22.37-10.86s6.3-10.25,7.84-12.77c2.09-3.41,3.57-3.42,5.05-3.58,4.84-.52,6-.4,7.11,0a2.18,2.18,0,0,1,1.38,1.57c1.28-.17,3.12-.69,3.89,1.28a5.83,5.83,0,0,1,.5,1.6,1.41,1.41,0,0,1,.93.25c1.34.93.66,5.51-.2,6.81-.6.92-1.7,1.3-3.23,1.49-1.29.15-1-1.27-1-1.27l-1.73.56c-3.08,3.68-1.87,9.06-6.57,11.55a36.21,36.21,0,0,0-5.8,2.79C378.06,198.49,366.39,206.8,362.71,208.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.81,164.26l-5.82.34,5.51-1.07A2.2,2.2,0,0,1,402.81,164.26Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.2,167.14l-6.58.85,6.4-1.59A4.21,4.21,0,0,1,407.2,167.14Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.1,170.17a2.06,2.06,0,0,1-.66,1,4.38,4.38,0,0,1-1,.66l.07-.08c-.09.38-.18.75-.28,1.12l-.18-.13a1.31,1.31,0,0,1,1.08,0,1.67,1.67,0,0,1,.77.69,2.07,2.07,0,0,0-.83-.53,1.32,1.32,0,0,0-.9.07L405,173l.05-.25c.09-.38.18-.76.28-1.13v-.06l.06,0a7.36,7.36,0,0,0,1-.57A2.55,2.55,0,0,0,407.1,170.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,171.43a20.11,20.11,0,0,1-2.26.77,2.61,2.61,0,0,1-.47,1.43,14.38,14.38,0,0,1-1,1.35l1.73-.56s.22-.9,1.71-1.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,182.9a51.71,51.71,0,0,1,12.41,1.75c3.76,1,17.53,3.62,21.47,4s13.21.85,13.21.85l12.19-5.26s2.15.73,4.34,5.26.74,10.5.74,10.5-10.77,7.44-13.11,8.95-3.68,1.86-7.28,1.6-27.65-1.75-30.39-1.44-3.5,1.28-5,2.17-5.63-.64-8.26-4.61S304.22,188.72,312,182.9Z",
    style: {
      fill: "#455a64"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmsLogin1);
export default __webpack_public_path__ + "static/media/HRMS-Login-1.422db4c9d733d00589327d29a8e77c13.svg";
export { ForwardRef as ReactComponent };